import React, { useState, useEffect, FC, useCallback, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Content from "../../layout/content/Content";
import {
  Card,
  Badge,
  Row,
  Col,
  Button,
  Modal,
  ModalBody,
  Spinner,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  ModalHeader,
  UncontrolledDropdown,
} from "reactstrap";
import Head from "../../layout/head/Head";
import {
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Icon,
} from "../../components/Component";
import { Controller, FormProvider, useForm } from "react-hook-form";
import {
  PaperClipOutlined,
  DownloadOutlined,
  DeleteOutlined,
  EditOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";
import {
  Form,
  Input,
  Table,
  Collapse as AntCollapse,
  Descriptions,
  Modal as AntModal,
  Spin,
  Flex,
  Popover,
  TableColumnsType,
  Timeline,
  Empty,
  UploadFile,
  Checkbox,
  DatePicker as AntDatePicker,
  Upload,
} from "antd";
import FormSelect from "../form-components/SelectComponent";
import FormInput from "../form-components/InputComponent";
import FormMultiSelect from "../form-components/MultiSelectComponent";
import FormDatePicker from "../form-components/DatePicker";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import axios from "axios";
import statusMapper from "../purchase-orders/StatusMapper";
import Misc from "../masters/Misc";
import Swal from "sweetalert2";
import usersApis from "../../api/master/users";
import quotationApis from "../../api/master/quotations";
import { useLocation } from "react-router-dom";
import { AddressDetails, Material, SelectOptions } from "./newQuotations/types";
import Dragger from "antd/es/upload/Dragger";
import costCenterApis from "../../api/master/costCenter";
import deliveryAddressApis from "../../api/master/deliveryAddress";
import MaterialModal from "./MaterialModal";
import supplierApis from "../../api/master/supplier";
import { useSelector } from "react-redux";
import { RootState } from "../../store/store";
import { formatDecimal } from "../../utils/Utils";
import PdfGenerator from "./BuyerToSellerPDF";
import EmailCreationModal from "./EmailCreationModal";
import FormTextArea from "../form-components/TextAreaComponent";
import contractorsApis from "../../api/master/contractors";
import brandMasterApis from "../../api/master/brandMaster";
import SignatureModal from "../purchase-orders/SignatureModal";
import ImageUploadCropper from "../components/ImageUploadCropper";
import { Link } from "react-router-dom";
import boqApis from "../../api/boq/boq";

dayjs.extend(utc);
const { Panel } = AntCollapse;

const { beforeUpload } = Misc;
const ViewDetailsEdit: FC<any> = () => {
  const [pdfBlobData, setPdfBlobData] = useState<any>({
    current: null,
    url: "",
    doc: null,
  });
  const [materialCategoryOptions, setMaterialCategoryOptions] = useState([]);
  const [showPdfModal, setShowPdfModal] = useState(false);
  const [formatedSuppliersList, setFormatedSuppliersList] = useState<any>([]);
  const [showEmailModal, setShowEmailModal] = useState(false);
  const [shareOptionsToggle, setShareOptionsToggle] = useState(false);
  const location = useLocation();
  const screenNavigationStatus = location.state?.screenStatus;
  const [isLoading, setIsLoading] = useState(true);
  const { data: currentUser }: any = useSelector(
    (state: RootState) => state.currentUser
  );
  let { qid }: any = useParams();
  const navigate = useNavigate();
  const [OriginalData, setOriginalData] = useState<any>({});
  const [siteIdWatch, setSiteIdWatch] = useState<number>();

  const [rfqStatus, setRfqStatus] = useState<any>("");
  const [sm, setSm] = useState(false);
  const [screenSize, setScreenSize] = useState(0);
  const [mobileView, setMobileView] = useState(false);
  const [instructionsVisible, setInstructionsVisible] = useState(false);
  const [termsVisible, setTermsVisible] = useState(false);
  const [materialData, setMaterialData] = useState<any>({});
  const [boqData, setBoqData] = useState<any[]>([]);
  const [deliveryDataColoumn, setDeliveryDataColumn] = useState<any>();
  const [attachments, setAttachments] = useState<any>([]);
  const [deletedAttachments, setDeletedAttachments] = useState<any>([]);
  const [newAttachments, setNewAttachments] = useState<any>([]);
  const [DMS, setDMS] = useState<any>([]);
  const [editLineRow, setEditLineRow] = useState<any>();
  const [generalInformationEdit, setGeneralInformationEdit] = useState(false);
  const [termsAndConditions, setTermsAndConditions] = useState<any>("");
  const [newTermsAndConditions, setNewTermsAndConditions] = useState<any>("");
  const [instructions, setInstructions] = useState("");
  const [newInstructions, setNewInstructions] = useState<any>("");
  const [isInstructionsChanged, setIsInstructionsChanged] = useState(false);
  const [approverIds, setApproverIds] = useState<any>([]);
  const [isTermsAndConditionsChanged, setIsTermsAndConditionsChanged] =
    useState(false);

  const [signature, setSignature] = useState({
    isActive: false,
    label: "Authorised Signatory",
    image: null as string | null,
  });

  const [showSignatureModel, setShowSignatureModel] = useState(false);

  const [isModalApproveVisible, setIsModalApproveVisible] = useState(false);
  const [approveRecord, setApproveRecord] = useState<any>(null);
  const [activeSignatureContext, setActiveSignatureContext] = useState<
    "APPROVE" | "REJECT" | null
  >(null);

  // Sealed Bid Received modal state
  const [sealedBidModal, setSealedBidModal] = useState<{
    open: boolean;
    supplierId: string;
    supplierName: string;
  }>({ open: false, supplierId: "", supplierName: "" });
  const [sealedBidReceivedDate, setSealedBidReceivedDate] = useState<any>(null);
  const [sealedBidFile, setSealedBidFile] = useState<any>(null);
  const [sealedBidSubmitting, setSealedBidSubmitting] = useState(false);
  const [supplierBidData, setSupplierBidData] = useState<any[]>([]);

  const [showActionModelVisible, setShowActionModelVisible] = useState(false);
  const [isModalRejectedVisible, setIsModalRejectedVisible] = useState(false);
  const [isStrictMode, setIsStrictMode] = useState<boolean>(false);

  const methods = useForm({
    mode: "onChange",
  });
  const [disableSubmit, setDisableSubmit] = useState(false);
  const [disableDraft, setDisableDraft] = useState(false);

  const [supplierData, setSupplierData] = useState<any>([]);
  const {
    handleSubmit,
    reset,
    watch,
    setValue,
    formState: { errors },
  } = methods;

  const termsAndConditionsWatch = watch("termsAndConditions");
  const instructionsWatch = watch("instructions");
  useEffect(() => {
    if (termsAndConditionsWatch) {
      setNewTermsAndConditions(termsAndConditionsWatch);
    }
  }, [termsAndConditionsWatch]);
  useEffect(() => {
    if (instructionsWatch) {
      setNewInstructions(instructionsWatch);
    }
  }, [instructionsWatch]);

  const [addNewRowModel, setAddNewRowModel] = useState<boolean>(false);
  const [data, setData] = useState<any>([]);
  const [showSubmitBtm, setShowSubmitBtm] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [rejectRecord, setRejectRecord] = useState<any>(null);
  const [form] = Form.useForm();
  const [sitesOptions, setSitesOptions] = useState<SelectOptions[]>([]);
  const [costCenterOptions, setCostCenterOptions] = useState<SelectOptions[]>(
    []
  );
  const [contractorOptions, setContractorOptions] = useState<SelectOptions[]>(
    []
  );
  const [billingAddressList, setBillingAddressList] = useState<
    AddressDetails[]
  >([]);
  const [billingAddressOptions, setBillingAddressOptions] = useState<
    SelectOptions[]
  >([]);
  const [suppliers, setSuppliers] = useState<any[]>([]);
  const [selectedArrayData, setSelectedArrayData] = useState([]);

  const [deliveryAddressOptions, setDeliveryAddressOptions] = useState<
    SelectOptions[]
  >([]);

  const [deliveryAddressList, setDeliveryAddressList] = useState<any>([]);
  const [brandOptions, setBrandOptions] = useState<SelectOptions[]>([]);

  const deliveryLevelTypeWatch = watch("deliveryLevelType");
  const deliveryDateTypeWatch = watch("deliveryDateType");
  const paymentTermsWatch = watch("paymentTerms");
  const isSealedBidWatch = watch("isSealedBid");
  const isStrictEvaluationTimerWatch = watch("isStrictEvaluationTimer");
  useEffect(() => {
    if (siteIdWatch) {
      fetchContractorList(siteIdWatch + "");
    }
  }, [siteIdWatch]);

  useEffect(() => {
    if (siteIdWatch) {
      fetchDeliveryAddressBySite(siteIdWatch);
    }
  }, [siteIdWatch]);

  useEffect(() => {
    fetchCategorys();
    fetchDetails();
    fetchCostCenter();
    fetchSites();
    fetchBrands();
    viewChange();
    window.addEventListener("load", viewChange);
    window.addEventListener("resize", viewChange);
    const headerClick = () => setSm(false);
    document
      .getElementsByClassName("nk-header")[0]
      ?.addEventListener("click", headerClick);

    return () => {
      window.removeEventListener("resize", viewChange);
      window.removeEventListener("load", viewChange);
      document
        .getElementsByClassName("nk-header")[0]
        ?.removeEventListener("click", headerClick);
    };
  }, []);

  const viewChange = () => {
    setScreenSize(window.innerWidth);
    if (window.innerWidth < 990) {
      setMobileView(true);
    } else {
      setMobileView(false);
      setSm(false);
    }
  };
  const fetchCategorys = async () => {
    try {
      const { data, status } = await supplierApis.fetchSupplierCategory();
      if (status) {
        const categoryOption = data.map((item: any) => ({
          label: item.category,
          value: item.id.toString(),
        }));
        setMaterialCategoryOptions(categoryOption);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const TriggerEmail = async (emailData: any, _methods: any) => {
    try {
      const formData = new FormData();
      formData.append("msgType", "purchaseOrderConfirmation");
      formData.append("supplierId", emailData?.supplierId);
      formData.append("logo", currentUser?.orgLogo);
      formData.append("email", emailData?.to);
      formData.append("cc", emailData?.cc);
      formData.append("bcc", emailData?.bcc);

      const _response: any = await quotationApis.getLatestBySupplierQuotationId(
        qid,
        emailData?.supplierId
      );
      if (!_response?.status) {
        return;
      }
      const supplierDataResponse = _response?.response?.data;

      const { pdfBlob: customePdfBlob }: any = await PdfGenerator(
        returnBillingDetails(OriginalData),
        returnSupplierDetails(OriginalData),
        returnDetails(supplierDataResponse?.quotationInfo?.quotationLines),
        currentUser?.orgLogo,
        false,
        termsAndConditions,
        OriginalData?.quotationApprovals || []
      );

      if (emailData?.attachments?.length > 0) {
        emailData?.attachments?.forEach((attachment: any, index: number) => {
          if (!attachment) {
            return;
          }
          let file: any = null;
          if (index == 0) {
            file = new File(
              [customePdfBlob],
              OriginalData?.quotationHeader?.rfqId + ".pdf",
              {
                type: "application/pdf",
              }
            );
          } else {
            file = attachment?.originFileObj;
          }
          formData.append(`files`, file);
        });
      }
      const response: any = await quotationApis.emailNotify(qid, formData);
      const { data, status } = response;
      if (status) {
        _methods.reset();
        Swal.fire("Success", "Email has been sent successfully", "success");
        setShowEmailModal(false);
      }
    } catch (error) {
      console.log(error);
      setShowEmailModal(false);
    }
  };

  const handleAttachmentChange = (info: { fileList: UploadFile[] }) => {
    setNewAttachments((pre: any) => {
      return [...pre, ...info.fileList];
    });
    setShowSubmitBtm(true);
  };

  const fetchHtmlContentFromUrl = async (url: string) => {
    try {
      const response = await axios.get(url, {
        headers: {
          "Content-Type": "text/html",
        },
      });

      return response?.data;
    } catch (error) {
      console.log(error);
      return null;
    }
  };

  const fetchSuppliers = async (LineItems: any) => {
    try {
      let allCat: any = [];
      LineItems?.forEach((item: any) => {
        allCat.push(item.categoryId);
      });
      const allCatString = allCat.join(",");
      const { data, status, message } =
        await supplierApis.fetchSuppliersByCategoryId({ id: allCatString });
      if (status) {
        let formatedData = data.map((item: any) => ({
          supplierName: item.supplierName,
          supplierID: item?.supplierOrgID
            ? item?.supplierOrgID?.toString()
            : item?.supplierID?.toString(),
        }));
        setSuppliers(formatedData);
        return formatedData;
      } else {
        throw new Error(message);
      }
    } catch (error) { }
  };

  const fetchDeliveryAddressBySite = async (siteId: any) => {
    try {
      const { data, status } = await deliveryAddressApis.fetchAddressBySite(
        siteId
      );
      if (status) {
        const addressOptions = data.map((item: any) => ({
          label: item.deliveryLocationName,
          value: item.id.toString(),
        }));
        setBillingAddressList(data);
        setBillingAddressOptions(addressOptions);
        setDeliveryAddressOptions(addressOptions);
        setDeliveryAddressList(data);
      }
    } catch (error) {
      console.log("Error fetching delivery addresses by site:", error);
    }
  };

  const fetchDetails = async () => {
    try {
      const res = await quotationApis.getById(qid);
      const { response, status, message } = res;
      if (status) {
        const data = response.data;

        const isStrict =
          data?.quotationHeader?.isStrictApproval === true || data?.quotationHeader?.isStrictApproval === 1;
        setIsStrictMode(isStrict);

        if (data?.quotationApprovals) {
          const processedApprovals = data.quotationApprovals.map((approval: any) => ({
            ...approval,
            level: approval.level?.toLowerCase() || approval.level,
            status: approval.status?.toLowerCase() || approval.status
          }));
          data.quotationApprovals = processedApprovals;

          // Filter pending approvals
          let ids = processedApprovals
            ?.filter((item: any) => item?.status?.toLowerCase() !== "approved")
            ?.map((item: any) => item?.userId);
          setApproverIds(ids);
        }

        setOriginalData(data);
        setSiteIdWatch(data.quotationHeader.siteId);
        setRfqStatus(data?.quotationHeader.status);
        // if (data?.quotationApprovals) {
        //   let ids = data?.quotationApprovals?.map((item: any) => item?.userId);
        //   ids = ids?.filter((item: any) => item?.status != "Approved");
        //   setApproverIds(ids);
        // }

        if (data?.addtionalData.selectedSuppliers) {
          const selectedSuppliersSet = new Set(
            data?.addtionalData.selectedSuppliers.map(String)
          );
          const filteredSuppliers = suppliers.filter((supplier) =>
            selectedSuppliersSet.has(supplier.supplierID)
          );
          setSupplierData(filteredSuppliers);
          setSelectedArrayData(data?.addtionalData.selectedSuppliers);
        }

        if (data?.quotationHeader?.dms?.length > 0) {
          setDMS(data?.quotationHeader?.dms);
          const _termsAndConditions = data?.quotationHeader?.dms?.find(
            (item: any) => item.moduleFileType == "termsAndConditions"
          );
          if (_termsAndConditions) {
            const data: any = await fetchHtmlContentFromUrl(
              _termsAndConditions?.filePath
            );
            setTermsAndConditions(data);
            setNewTermsAndConditions(data);
          }
          const _instructions = data?.quotationHeader?.dms?.find(
            (item: any) => item.moduleFileType == "instructions"
          );
          if (_instructions) {
            const data: any = await fetchHtmlContentFromUrl(
              _instructions?.filePath
            );
            setInstructions(data);
            setNewInstructions(data);
          }
          const _attachments = data?.quotationHeader?.dms?.filter(
            (item: any) => item.moduleFileType == "attachments"
          );
          if (_attachments) {
            setAttachments(
              _attachments.map((attachment: any) => ({
                docId: attachment?.docId,
                fileName: attachment?.fileName,
                link: attachment?.filePath,
                moduleFileType: attachment?.moduleFileType,
                module: attachment?.module,
                label: "attachments",
                isActive: true,
              }))
            );
          }
        }
        setMaterialData(data);

        // Fetch BOQ data for quantity validation
        const headerSiteId = data?.quotationHeader?.siteId;
        const headerContractorId = data?.quotationHeader?.contractorId;
        if (headerSiteId && headerContractorId) {
          try {
            const boqResponse = await boqApis.fetchContractorBoqDropdown({
              siteIds: headerSiteId.toString(),
              contractorIds: headerContractorId.toString(),
            });
            const boqList = boqResponse?.data || boqResponse?.response || [];
            setBoqData(Array.isArray(boqList) ? boqList : []);
          } catch (err) {
            console.log("Failed to fetch BOQ data:", err);
            setBoqData([]);
          }
        }

        // Store supplier bid data from API response
        setSupplierBidData(
          data?.addtionalData?.suppliers || data?.suppliers || []
        );
        console.log(
          "data?.quotationHeader?.deliveryDateType",
          data?.quotationHeader?.deliveryDateType
        );
        setDeliveryDataColumn(data?.quotationHeader?.deliveryDateType);
        const LineItems: any = data?.quotationLines?.map((item: any) => {
          const file = item.dms?.find(
            (doc: any) => doc.quotationLineId == item.quotationLineId
          );
          if (file) {
            item.file = file;
            item.attachment = true;
          } else item.attachment = false;
          return item;
        });
        setData(LineItems);
        setShowSubmitBtm(false);
        setDeletedAttachments([]);
        setNewAttachments([]);
        if (LineItems) {
          const _suppliers: any = await fetchSuppliers(LineItems);
          setFormatedSuppliersList(_suppliers);
        }
      }
      setIsLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  const parseLevelNum = (level: any) => {
    if (!level && level !== 0) return NaN;
    const str = String(level).toLowerCase();

    // Handle various level formats: level1, Level2, L1, L2, etc.
    if (str.includes('level')) {
      const match = str.match(/\d+/);
      return match ? parseInt(match[0], 10) : NaN;
    } else if (str.startsWith('l')) {
      const match = str.match(/\d+/);
      return match ? parseInt(match[0], 10) : NaN;
    }
    return NaN;
  };

  const hasUserAlreadyApproved = materialData?.quotationApprovals?.some(
    (a: any) =>
      a.userId === currentUser?.id &&
      a.status?.toUpperCase() === "APPROVED"
  );

  const canUserApproveReject = useCallback(() => {
    // 1. Admin can Approve/Reject anytime - Buttons are always ENABLED
    if (currentUser?.genericRole?.toLowerCase() === "admin") {
      return true;
    }

    const approvals = materialData?.quotationApprovals || [];

    // Find current user's approval entry
    const userApproval = approvals.find(
      (approval: any) => approval.userId === currentUser?.id
    );

    if (!userApproval || userApproval.status?.toLowerCase() !== "pending") {
      return false;
    }

    const userLevelNum = parseLevelNum(userApproval.level ?? currentUser?.approvalLevel);

    // 2. Strict = 0 (Flexible mode)
    // Anyone in the approval list can approve at any time
    if (isStrictMode === false) {
      // In flexible mode, just check if user is in the approval list and pending
      return true;
    }

    // 3. Strict = 1 (Sequential mode)
    // Must follow the order. Level 2 cannot see buttons until Level 1 is "Approved"
    if (isStrictMode === true) {
      // Get all pending approvals sorted by level
      const pendingApprovals = approvals
        .filter((approval: any) => approval.status?.toLowerCase() === "pending")
        .sort((a: any, b: any) => {
          const aNum = parseLevelNum(a.level);
          const bNum = parseLevelNum(b.level);
          if (isNaN(aNum) || isNaN(bNum)) return 0;
          return aNum - bNum;
        });

      // If there are no pending approvals, user can't approve
      if (pendingApprovals.length === 0) return false;

      // Get the first pending approval (lowest level)
      const firstPending = pendingApprovals[0];
      const firstPendingLevelNum = parseLevelNum(firstPending.level);

      // Check if user is the first pending approver
      return userApproval.userId === firstPending.userId &&
        userLevelNum === firstPendingLevelNum;
    }

    return false;
  }, [currentUser, currentUser?.id, materialData?.quotationApprovals, isStrictMode]);

  const getPendingStatusMessage = () => {
    const approvals = materialData?.quotationApprovals || [];
    const userApproval = approvals.find(
      (approval: any) => approval.userId === currentUser?.id
    );

    if (userApproval && userApproval.status?.toUpperCase() === "APPROVED") {
      return "You have already approved this purchase request.";
    }

    const pendingApprovals = approvals
      .filter((approval: any) => approval.status?.toLowerCase() === "pending")
      .sort((a: any, b: any) => {
        const aNum = parseLevelNum(a.level);
        const bNum = parseLevelNum(b.level);
        if (isNaN(aNum) || isNaN(bNum)) return 0;
        return aNum - bNum;
      });

    if (pendingApprovals?.length > 0) {
      if (!isStrictMode) {
        // Flexible mode - any approver can approve
        const approverNames = pendingApprovals.map((approval: any) => approval.userName).join(", ");
        return `Status is pending. Any of these approvers can approve: ${approverNames}`;
      } else {
        // Strict mode - must follow sequence
        const nextApprover = pendingApprovals[0];
        const lvl = parseLevelNum(nextApprover.level);
        const levelText = !isNaN(lvl) ? `Level ${lvl}` : nextApprover.roleName || "";
        return `Status is pending. Waiting for ${nextApprover.userName} (${levelText}) to approve first.`;
      }
    }

    return "Status is pending by other approvers";
  };


  const fetchCostCenter = async () => {
    try {
      const { data, status } = await costCenterApis.fetchCostCenter();
      if (status) {
        const costCenterOptions = data.map((item: any) => ({
          label: item.costCenterName,
          value: item.id.toString(),
        }));
        setCostCenterOptions(costCenterOptions);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const fetchContractorList = async (siteId: any) => {
    try {
      const { data, status } = await contractorsApis.fetchContractorBySiteId({
        id: siteId,
      });
      if (status) {
        let contractorOptions = data.map((item: any) => ({
          label: item?.companyName,
          value: item?.contractorID?.toString(),
        }));
        setContractorOptions(contractorOptions);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchSites = async () => {
    try {
      const data = await usersApis.getCurrentUser();
      if (data) {
        let sitesOptions = data?.siteAccessibility?.map((item: any) => ({
          label: item.siteName,
          value: item.siteID.toString(),
        }));
        setSitesOptions(sitesOptions);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchBrands = async () => {
    try {
      const response: any = await brandMasterApis.fetchBrandDropDown();
      const {
        data: brandsList,
        status,
      }: {
        status: boolean;
        data: { name: string; id: number }[];
      } = response || {};
      if (status) {
        const brandOptions = brandsList.map((brand: any) => ({
          label: brand.name,
          value: brand.id.toString(),
        }));
        setBrandOptions(brandOptions);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const [columns] = useState<TableColumnsType<any>>([
    {
      title: "#",
      key: "index",
      width: 50,
      render: (text: any, record: any, index: number) => index + 1,
    },
    {
      title: "Category",
      dataIndex: "categoryName",
      key: "categoryName",
      fixed: "left" as const,
      // width: 150,
    },
    {
      title: "Material Name",
      dataIndex: "materialName",
      key: "materialName",
      // width: 200,
    },
    {
      title: "Make",
      dataIndex: "makeInfo",
      key: "makeInfo",
      width: 150,
      render: (_: any, record: any) => {
        if (record?.makeInfo?.length > 0) {
          return record.makeInfo.map((m: any) => m.makeName).join(", ");
        }
        return record?.makeLabel || "-";
      },
    },
    {
      title: "Specification",
      dataIndex: "specification",
      key: "specification",
      width: 200,
    },
    {
      title: "QTY",
      dataIndex: "quantity",
      key: "qty",
      width: 170,
      render: (text: any, record: any) => (
        <>
          {/* {console.log("awardedQty", record.awardedQty)} */}
          {Number(text).toLocaleString("en-IN")}
          {/* {record.awardedQty} */}
          {record.awardedQty !== 0 && record.awardedQty !== undefined && (
            <Popover
              content={
                <div>
                  {/* Convert awardedQty to a number and handle invalid values */}
                  <p>
                    Converted Qty:{" "}
                    {!isNaN(Number(record?.awardedQty))
                      ? Number(record.awardedQty).toLocaleString("en-IN")
                      : "N/A"}
                  </p>
                </div>
              }
              title="Info"
            >
              <InfoCircleOutlined style={{ marginLeft: 8 }} />
            </Popover>
          )}
        </>
      ),
    },
    {
      title: "UOM",
      dataIndex: "uomName",
      key: "uomName",
      // width: 150,
    },
    {
      title: "NEED BY DATE",
      dataIndex: "deliveryDate",
      key: "deliveryDate",
      render: (text) => {
        return dayjs(text).format("DD-MMM-YYYY");
      },
    },
    {
      title: "Action",
      key: "operation",
      fixed: "right",
      width: 150,
      hidden: false,
      render: (text, record: any, index) => (
        <Button
          size="sm"
          color=""
          onClick={() => {
            setEditLineRow(record);
          }}
        >
          <Icon name="edit" />
        </Button>
      ),
    },
  ]);

  const filteredColumns = columns.filter((col) => {
    if (
      col.key === "operation" &&
      ["Awarded", "Negotiated", "Quoted"].includes(rfqStatus)
    ) {
      return false; // Remove "operation" column if rfqStatus is in these states
    }

    if (deliveryDataColoumn === "LINE_LEVEL") {
      return true; // Keep all columns
    }

    return col.key !== "deliveryDate"; // Hide "deliveryDate" when it's not "LINE_LEVEL"
  });

  const handleCheckboxChange = (supplierID: any) => (event: any) => {
    console.log("PreviousData::selectedArrayData", selectedArrayData);
    console.log("supplierID", supplierID);
    let isChecked = event.target.checked;
    setValue(`supplier_${supplierID}`, isChecked);
    console.log("isChecked", isChecked);
    setSelectedArrayData((prevSelectedArrayData: any) => {
      if (isChecked) {
        // Add ID to the array
        console.log("add", [...prevSelectedArrayData, Number(supplierID)]);
        return [...prevSelectedArrayData, Number(supplierID)];
      } else {
        // Remove ID from the array
        console.log(
          "remove",
          prevSelectedArrayData.filter((id: any) => id !== Number(supplierID))
        );
        return prevSelectedArrayData.filter(
          (id: any) => id !== Number(supplierID)
        );
      }
    });
    setShowSubmitBtm(true); // Show submit button when any checkbox is changed
  };

  // Sealed Bid - Check if "Received" button should be visible
  const excludedSealedBidStatuses = [
    "PENDING",
    "DRAFT",
    "REJECTED",
    "CANCELLED",
    "ON_HOLD",
    "REGRETTED",
  ];
  const isSealedBidActive =
    (materialData?.quotationHeader?.isSealedBid === true ||
      materialData?.quotationHeader?.isSealedBid === "Y") &&
    !excludedSealedBidStatuses.includes(rfqStatus?.toUpperCase());

  const handleSealedBidCapture = async () => {
    if (!sealedBidReceivedDate) {
      Swal.fire("Error!", "Please select received date & time", "error");
      return;
    }
    try {
      setSealedBidSubmitting(true);
      const formData = new FormData();
      const body: any = {
        quotationId: Number(materialData?.quotationHeader?.quotationId),
        supplierId: Number(sealedBidModal.supplierId),
        receivedDate: dayjs(sealedBidReceivedDate).format(
          "YYYY-MM-DD HH:mm:ss"
        ),
      };
      if (sealedBidFile) {
        body.docKeys = [
          {
            fileIndex: 0,
            module: "Quotation",
            moduleFileType: "Bid Supporting Docs",
          },
        ];
        formData.append("files", sealedBidFile);
      }
      formData.append("body", JSON.stringify(body));
      const res: any = await quotationApis.captureSealedBid(formData);
      if (res?.status) {
        Swal.fire(
          "Success!",
          `Sealed bid received for ${sealedBidModal.supplierName}`,
          "success"
        );
        setSealedBidModal({ open: false, supplierId: "", supplierName: "" });
        setSealedBidReceivedDate(null);
        setSealedBidFile(null);
        // Refresh data to update bid status
        fetchDetails();
      } else {
        Swal.fire("Error!", res?.message || "Something went wrong", "error");
      }
    } catch (error) {
      console.error("Sealed bid capture error:", error);
      Swal.fire("Error!", "Failed to capture sealed bid", "error");
    } finally {
      setSealedBidSubmitting(false);
    }
  };

  const renderSupplierSection = (
    suppliers: { supplierName: string; supplierID: string }[]
  ) => {
    const isDisabled = ["Awarded", "Negotiated", "Quoted"].includes(rfqStatus);
    const selectedSuppliersSet: any = new Set(
      (OriginalData?.addtionalData?.selectedSuppliers || []).map((id: any) =>
        String(id)
      )
    );

    return (
      <div
        style={{
          border: "1px solid #e5e9f2",
          borderRadius: "8px",
          overflow: "hidden",
          marginTop: "10px",
        }}
      >
        {/* Header */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            padding: "8px 14px",
            borderBottom: "1px solid #e5e9f2",
            fontWeight: 600,
            fontSize: "13px",
            color: "#526484",
          }}
        >
          <div style={{ flex: "0 0 30px" }}>#</div>
          <div style={{ flex: "0 0 30px" }}></div>
          <div style={{ flex: 1 }}>Supplier Name</div>
          {isSealedBidActive && (
            <div style={{ flex: 1, textAlign: "left" }}>Bid Status</div>
          )}
        </div>
        {/* Rows */}
        {suppliers.map((supplier, idx) => {
          const isSelected = selectedSuppliersSet.has(supplier.supplierID);
          const bidInfo = supplierBidData.find(
            (s: any) =>
              String(s.supplierId) === String(supplier.supplierID) ||
              String(s.referencedSupplierId) === String(supplier.supplierID)
          );
          const isBidReceived = bidInfo?.bidReceived === true;

          return (
            <div
              key={supplier.supplierID}
              style={{
                display: "flex",
                alignItems: "center",
                padding: "10px 14px",
                borderBottom:
                  idx < suppliers.length - 1
                    ? "1px solid #e5e9f2"
                    : "none",
                background: "#fff",
              }}
            >
              {/* Index */}
              <div
                style={{
                  flex: "0 0 30px",
                  fontSize: "12px",
                  color: "#8094ae",
                }}
              >
                {idx + 1}
              </div>
              {/* Checkbox */}
              <div style={{ flex: "0 0 30px" }}>
                <Controller
                  name={`supplier_${supplier.supplierID}`}
                  control={methods.control}
                  defaultValue={isSelected}
                  render={({ field }) => (
                    <Checkbox
                      {...field}
                      checked={field.value}
                      onChange={handleCheckboxChange(supplier.supplierID)}
                      disabled={isDisabled}
                    />
                  )}
                />
              </div>
              {/* Name */}
              <div
                style={{
                  flex: 1,
                  fontSize: "13px",
                  fontWeight: isSelected ? 500 : 400,
                  color: isSelected ? "#333" : "#666",
                }}
              >
                {supplier.supplierName}
              </div>
              {/* Bid Status — only for selected suppliers when sealed bid is active */}
              {isSealedBidActive && (
                <div style={{ flex: 1 }}>
                  {isSelected && !isBidReceived && (
                    <button
                      type="button"
                      className="btn btn-sm btn-primary"
                      style={{
                        padding: "3px 14px",
                        fontSize: "12px",
                        borderRadius: "4px",
                      }}
                      onClick={(e) => {
                        e.stopPropagation();
                        setSealedBidModal({
                          open: true,
                          supplierId: supplier.supplierID,
                          supplierName: supplier.supplierName,
                        });
                        setSealedBidReceivedDate(null);
                        setSealedBidFile(null);
                      }}
                    >
                      Received ?
                    </button>
                  )}
                  {isSelected && isBidReceived && (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                        flexWrap: "wrap",
                      }}
                    >
                      <span
                        className="badge bg-success"
                        style={{
                          fontSize: "11px",
                          padding: "4px 8px",
                        }}
                      >
                        Bid Received
                      </span>
                      {bidInfo?.bidReceivedDate && (
                        <span style={{ fontSize: "12px", color: "#555" }}>
                          {dayjs
                            .utc(bidInfo.bidReceivedDate)
                            .format("DD-MMM-YYYY hh:mm A")}
                        </span>
                      )}
                      {bidInfo?.bidDocs?.length > 0 &&
                        bidInfo.bidDocs.map((doc: any) => (
                          <a
                            key={doc.docId}
                            href={doc.filePath}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ fontSize: "12px" }}
                            title={doc.fileName}
                          >
                            <PaperClipOutlined /> {doc.fileName}
                          </a>
                        ))}
                    </div>
                  )}
                </div>
              )}
            </div>
          );
        })}
      </div>
    );
  };

  const ApprovalTimelineContent = () => {
    const approvalsData = OriginalData?.quotationApprovals;
    if (!approvalsData || approvalsData?.length === 0) {
      return <Badge color="outline-danger">No</Badge>;
    }

    return (
      <Popover
        content={
          <Timeline className="approval-timeline">
            {approvalsData?.map((approval: any, index: number) => {
              const isApproved = approval.status?.toLowerCase() == "approved";
              const isRejected = approval.status?.toLowerCase() == "rejected";
              return (
                <Timeline.Item
                  key={index}
                  dot={
                    isApproved ? (
                      <CheckCircleOutlined style={{ color: "green" }} />
                    ) : isRejected ? (
                      <CloseCircleOutlined style={{ color: "red" }} />
                    ) : undefined
                  }
                >
                  {approval?.userName}
                  <div className="designation">{approval?.roleName}</div>
                  {approval?.approvalDate && (
                    <div className="designation">
                      {dayjs(approval?.approvalDate).format("DD-MMM-YYYY")}
                    </div>
                  )}
                </Timeline.Item>
              );
            })}
          </Timeline>
        }
        title={<span style={{ color: "#2263b3" }}>Approval Hierarchy</span>}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            cursor: "pointer"
          }}>
          <span
            style={{
              color: "#2263b3",
            }}
          >
            <Badge color="outline-success">Yes</Badge>
          </span>
          {isStrictMode && (
            <Badge
              color="warning"
              style={{
                fontSize: "11px",
                cursor: "pointer",
                marginLeft: "4px"
              }}
              title="Sequential approvals required, Approvals must follow the sequence"
            >
              Strict
            </Badge>
          )}
        </div>
      </Popover>
    );
  };

  const billingAddressContent = materialData?.quotationHeader
    ?.billingAddressName ? (
    <div className="billingAddress_align">
      <strong>
        {
          materialData?.quotationHeader?.billingAddressName
            ?.deliveryLocationName
        }
      </strong>
      <br></br>
      <p>
        {materialData?.quotationHeader?.billingAddressName?.addressLine1},{" "}
        {materialData?.quotationHeader?.billingAddressName?.addressLine2}
      </p>
      <p>
        {materialData?.quotationHeader?.billingAddressName?.city},{" "}
        {
          materialData?.quotationHeader?.billingAddressName?.district
            ?.districtName
        }
        , {materialData?.quotationHeader?.billingAddressName?.state?.stateName},{" "}
        {
          materialData?.quotationHeader?.billingAddressName?.countryInfo
            ?.countryName
        }{" "}
        - {materialData?.quotationHeader?.billingAddressName?.pincode}
      </p>
      <p>
        <strong>GSTIN</strong> : {materialData?.quotationHeader?.gstin}
      </p>
      <p>
        <strong>CIN</strong> : {materialData?.quotationHeader?.cin}
      </p>
      <p>
        <strong>PAN</strong> : {materialData?.quotationHeader?.pan}
      </p>
      <p>
        <strong>Phone</strong> : {materialData?.quotationHeader?.phoneNumber}
      </p>
    </div>
  ) : null;

  const orderDeliveryAddressContent = materialData?.quotationHeader
    ?.deliveryAddressName ? (
    <div className="billingAddress_align">
      <strong>
        {
          materialData?.quotationHeader?.deliveryAddressName
            ?.deliveryLocationName
        }
      </strong>
      <p>
        {materialData?.quotationHeader?.deliveryAddressName?.addressLine1},{" "}
        {materialData?.quotationHeader?.deliveryAddressName?.addressLine2}
      </p>
      <p>
        {materialData?.quotationHeader?.deliveryAddressName?.cityName},{" "}
        {
          materialData?.quotationHeader?.deliveryAddressName?.district
            ?.districtName
        }
        , {materialData?.quotationHeader?.deliveryAddressName?.state?.stateName}
        ,{" "}
        {
          materialData?.quotationHeader?.deliveryAddressName?.countryInfo
            ?.countryName
        }{" "}
        - {materialData?.quotationHeader?.deliveryAddressName?.pincode}
      </p>
      <p>
        <p>
          <strong>Contact Person</strong> :{" "}
          {
            materialData?.quotationHeader?.deliveryAddressName
              ?.contactPersonName
          }
        </p>
        <p>
          <strong>Mobile Number</strong> :{" "}
          {materialData?.quotationHeader?.deliveryAddressName?.mobileNumber}
        </p>
      </p>
    </div>
  ) : null;

  useEffect(() => {
    if (editLineRow) {
      setAddNewRowModel(true);
    }
  }, [editLineRow]);

  const requiredDocsContent = OriginalData?.requiredDocs ? (
    <Table
      dataSource={OriginalData?.requiredDocs?.map(
        (doc: any, index: number) => ({
          key: index + 1,
          sNo: index + 1,
          documentName: doc.documentName,
          mandatory: doc.mandatory ? "Yes" : "No",
        })
      )}
      columns={[
        {
          title: "S.No",
          dataIndex: "sNo",
          key: "sNo",
        },
        {
          title: "Document Name",
          dataIndex: "documentName",
          key: "documentName",
        },
        {
          title: "Mandatory to Upload",
          dataIndex: "mandatory",
          key: "mandatory",
        },
      ]}
      pagination={false}
      size="small"
      style={{ minWidth: "200px" }}
    />
  ) : null;

  const SubmitChanges = async (submitStatus: any) => {
    try {
      const _formData = new FormData();
      const updatedLineItems: any = [];
      const newfiledata: any = [];
      const deletedFileData: any = [...deletedAttachments];
      const updatedFileData: any = [];
      materialData.addtionalData.selectedSuppliers = selectedArrayData;
      materialData?.quotationLines?.forEach((data: any) => {
        if (!data?.quotationLineId) {
          if (data?.file && data?.file[0]) {
            data.fileIndex = newfiledata.length;
            const fileLine = new File([data.file[0]], data.file[0].name);
            _formData.append("files", fileLine);
            newfiledata.push({
              fileIndex: newfiledata.length,
              module: "Quotation",
              moduleFileType: "Special Instructions",
              level: "LINE_LEVEL",
            });
          }
        } else {
          const OData = OriginalData?.quotationLines?.find(
            (item: any) => item.quotationLineId == data.quotationLineId
          );
          console.log("OData", OData);
          let updatedItem: any = {};
          updatedItem.quotationLineId = data.quotationLineId;
          // if (Number(OData.quantity) !== Number(data.quantity)) {
          //     updatedItem.quantity = Number(data.quantity);
          // }

          // if (Number(OData.categoryId) !== Number(data.categoryId)) {
          //     updatedItem.categoryId = Number(data.categoryId);
          // }

          // if (OData.description !== data.description) {
          //     updatedItem.description = data.description;
          // }

          if (Object.keys(updatedItem).length > 0) {
            //     if (OriginalData?.needByDateType == "Line Level") {
            //         updatedItem.needByDate = dayjs(data.needByDate).format(
            //             "YYYY-MM-DD"
            //         );
            //     }
            //     if (OriginalData?.deliveryAddressType == "Line Level") {
            //         updatedItem.deliveryAddressId = Number(data.deliveryAddressId);
            //     }
            //     updatedItem.materialId = Number(data.materialId);
            updatedItem.quotationLineId = data.quotationLineId;
            //     updatedItem.uuid = OData.uuid;
            updatedLineItems.push(updatedItem);
          }

          if (data?.file && data?.file[0]) {
            if (OData?.dms[0]?.docId) {
              deletedFileData.push({
                docId: OData?.dms[0]?.docId,
              });
            }
            data.fileIndex = newfiledata.length;
            newfiledata.push({
              fileIndex: newfiledata.length,
              module: "Quotation",
              moduleFileType: "Special Instructions",
              quotationLineId: OData.quotationLineId,
              level: "LINE_LEVEL",
            });
            const fileLine = new File([data.file[0]], data.file[0].name);
            _formData.append("files", fileLine);
          }
        }
      });

      newAttachments.forEach((attachment: any, index: number) => {
        if (!attachment) {
          return;
        }
        const file = attachment?.originFileObj;

        _formData.append("files", file);
        newfiledata.push({
          fileIndex: newfiledata.length,
          module: "Quotations",
          moduleFileType: "attachments",
          level: "HEADER_LEVEL",
        });
      });

      const existingLineItems: any = [];
      OriginalData?.quotationLines?.forEach((item: any) => {
        if (item?.quotationLineId) {
          const obj: any = {
            quotationLineId: item.quotationLineId,
            materialId: item.materialId,
          };
          if (OriginalData?.needByDateType == "Line Level") {
            obj.needByDate = item.needByDate;
          }
          if (OriginalData?.deliveryAddressType == "Line Level") {
            obj.deliveryAddressId = item.deliveryAddressId;
          }
          existingLineItems.push(obj);
        }
      });

      if (isInstructionsChanged) {
        const instructionsFile = new Blob([newInstructions], {
          type: "text/html",
        });
        _formData.append(
          `files`,
          new File([instructionsFile], "instructions.html", {
            type: "text/html",
          })
        );
        newfiledata.push({
          fileIndex: newfiledata.length,
          module: "Quotations",
          moduleFileType: "instructions",
          level: "HEADER_LEVEL",
        });
        setIsInstructionsChanged(false);
        const _instructions = DMS?.find(
          (item: any) => item.moduleFileType == "instructions"
        );
        if (_instructions?.docId) {
          deletedFileData.push({
            docId: _instructions.docId,
          });
        }
      }
      if (isTermsAndConditionsChanged) {
        const termsAndConditionsFile = new Blob([newTermsAndConditions], {
          type: "text/html",
        });
        _formData.append(
          `files`,
          new File([termsAndConditionsFile], "termsAndConditions.html", {
            type: "text/html",
          })
        );
        newfiledata.push({
          fileIndex: newfiledata.length,
          module: "Quotations",
          moduleFileType: "termsAndConditions",
          level: "HEADER_LEVEL",
        });
        setIsTermsAndConditionsChanged(false);
        const _termsAndConditions = DMS?.find(
          (item: any) => item.moduleFileType == "termsAndConditions"
        );
        if (_termsAndConditions?.docId) {
          deletedFileData.push({
            docId: _termsAndConditions.docId,
          });
        }
      }

      let lastSubmissionDate = dayjs(
        materialData.quotationHeader?.lastSubmissionDate
      ).format("YYYY-MM-DD HH:mm:ss");
      materialData.quotationHeader.lastSubmissionDate = lastSubmissionDate;
      materialData.quotationHeader.status = submitStatus;
      const filesData = {
        newfiledata,
        deletedFileData,
        updatedFileData,
      };
      materialData.quotationLines.forEach((item: any) => {
        if (materialData.quotationHeader.deliveryLevelType === "ORDER_LEVEL") {
          item.deliveryAddressId = null;
          item.deliveryAddressName = null;
        }
        if (materialData.quotationHeader.deliveryDateType === "ORDER_LEVEL") {
          item.deliveryDate = null;
        }
      });

      _formData.append("filesData", JSON.stringify(filesData));

      // _formData.append("files", JSON.stringify([]));

      _formData.append(
        "quotationHeader",
        JSON.stringify(materialData.quotationHeader)
      );
      _formData.append(
        "quotationLines",
        JSON.stringify(materialData.quotationLines)
      );
      _formData.append(
        "requiredDocs",
        JSON.stringify(materialData.requiredDocs)
      );
      _formData.append(
        "quotationApprovals",
        JSON.stringify(materialData.quotationApprovals)
      );

      _formData.append(
        "additionalData",
        JSON.stringify(materialData.addtionalData)
      );
      console.log("MaterialDAta::::", materialData);

      // return

      const res = await quotationApis.newVersion(_formData);
      const { response, status, message }: any = res;
      if (status === true) {
        fetchDetails();
        Swal.fire("Updated!", message, "success");
        Swal.fire({
          icon: "success",
          title: "Updated",
          text: response.rfqId,
        });
        navigate("/view-rfqs");
      } else {
        Swal.fire("Error!", message, "error");
      }
    } catch (error) {
      console.log(error);
    } finally {
      setDisableSubmit(false);
      setDisableDraft(false);
    }
  };

  const returnBillingDetails = (OriginalData: any) => {
    if (!OriginalData?.quotationHeader?.billingAddressName) {
      return {};
    }
    let address = OriginalData.quotationHeader.billingAddressName;
    if (!address) {
      return {};
    }
    return {
      name: currentUser?.orgName || "",
      addressLine1: address.addressLine1,
      addressLine2: address.addressLine2,
      city: address.cityName,
      state: address?.state?.stateName,
      pincode: address.pincode,
      country: address?.countryInfo?.countryName,
      gstin: OriginalData?.quotationHeader?.gstin || "N/A",
      pan: currentUser?.pan || "",
      cin: currentUser?.cin || "",
    };
  };

  const returnSupplierDetails = (OriginalData: any) => {
    let seller = OriginalData?.supplierDetails;
    if (!seller) {
      return {};
    }
    return {
      name: OriginalData?.supplierName || "",
      addressLine1: seller?.address?.area || "",
      addressLine2: seller?.address?.district?.districtName || "",
      city: seller?.address?.city || "",
      state: seller?.address?.state?.stateName || "",
      pincode: seller?.address?.pincode || "",
      country: seller?.address?.country?.countryName || "",
      gstin: seller?.gstin || "",
      pan: seller?.pan || "",
      cin: seller?.cin || "",
    };
  };

  const returnDetails = (lineData: any) => {
    try {
      let address: any = OriginalData?.quotationHeader?.deliveryAddressName;
      return {
        quoteNumber: OriginalData?.quotationHeader?.rfqId,
        quoteDate: dayjs(OriginalData?.quotationHeader?.createdAt).format(
          "DD-MMM-YYYY"
        ),
        terms: "",
        expectedShipmentDate:
          materialData?.deliveryAddressType == "Order Level"
            ? dayjs(materialData?.needByDate).format("DD-MMM-YYYY")
            : "",
        placeofSupply: address?.cityName || "",
        contactPersonName: address?.contactPersonName || "N/A",
        mobileNumber: address?.mobileNumber || "N/A",
        creditDays:
          materialData?.paymentTerms != "Cash and Carry"
            ? materialData?.creditDays
            : 0,
        deliveryAddressString:
          [
            address?.addressLine1,
            address?.addressLine2,
            address?.cityName,
            address?.district?.districtName,
            address?.state?.stateName,
            address?.pincode?.toString(),
            address?.countryInfo?.countryName,
          ]
            ?.filter(Boolean)
            ?.join(", ") || "",
        totals: {
          taxableAmount: formatDecimal(
            materialData?.lineItems?.reduce(
              (a: any, b: any) => a + Number(b.quantity) * Number(b.unitPrice),
              0
            )
          ),
          cgst: formatDecimal(
            materialData?.lineItems?.reduce(
              (a: any, b: any) => a + Number(b.cgst),
              0
            )
          ),
          sgst: formatDecimal(
            materialData?.lineItems?.reduce(
              (a: any, b: any) => a + Number(b.sgst),
              0
            )
          ),
          igst: formatDecimal(
            materialData?.lineItems?.reduce(
              (a: any, b: any) => a + Number(b.igst),
              0
            )
          ),
          total: formatDecimal(
            materialData?.lineItems?.reduce(
              (a: any, b: any) => a + Number(b.grossTotal),
              0
            )
          ),
        },
        lines: lineData?.map((item: any, index: any) => {
          let itemDescription = item?.materialName;
          if (item?.description) {
            itemDescription += "\t" + item?.description;
          }
          if (materialData?.deliveryAddressType != "ORDER_LEVEL") {
            let _address = deliveryAddressList?.find(
              (_item: any) => _item?.id == item?.deliveryAddressId
            );
            if (_address) {
              const addressString = [
                _address.addressLine1,
                _address.addressLine2,
                _address.city,
                _address.stateName,
                _address.pincode?.toString(),
                _address.countryName,
              ]
                .filter(Boolean)
                .join(", ");
              itemDescription += "\n\nDelivery Address: " + addressString;
            }
          }
          return {
            sno: index + 1,
            itemDescription,
            specification: item?.specification,
            hsnSac: item?.hsnCode || "N/A",
            rate: formatDecimal(item?.unitPrice || 0),
            cgstPercentage: Number(item?.cgstPercentage || 0),
            cgstAmount: formatDecimal(item?.cgst || 0),
            sgstPercentage: Number(item?.sgstPercentage || 0),
            sgstAmount: formatDecimal(item?.sgst || 0),
            igstPercentage: Number(item?.igstPercentage || 0),
            igstAmount: formatDecimal(item?.igst || 0),
            taxableAmount: formatDecimal(item?.grossTotal || 0),
            qty: Number(item?.quantity) + " " + item?.uomName,
            uom: item?.uomLabel,
          };
        }),
      };
    } catch (error) {
      console.log(error);
      return {};
    }
  };

  const dataURLToFile = (dataUrl: string, fileName: string): File => {
    const arr = dataUrl.split(",");
    const mimeMatch = arr[0].match(/:(.*?);/);
    const mime = mimeMatch ? mimeMatch[1] : "image/png";
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], fileName, { type: mime });
  };

  const handleOk = async () => {
    try {
      const values = await form.validateFields();

      // Assuming `record.headerId` is used to identify the purchase order
      const payload = {
        headerId: rejectRecord,
        reason: values.reason,
      };

      // Call the API to submit the rejection
      await apiCallToRejectBudget(rejectRecord, values.reason);

      // Handle success (e.g., show a success message, refresh the table)

      setIsModalVisible(false);
      form.resetFields();
    } catch (error) {
      // Handle validation errors or API errors
    }
  };

  const apiCallToRejectBudget = async (quotationId: any, reason: string) => {
    // Replace this with your actual API call logic
    try {
      const files: File[] = [];
      if (signature.image) {
        files.push(dataURLToFile(signature.image as string, "signature.png"));
      }

      const res = await quotationApis.reject(quotationId, reason, files);
      const { response, status, message } = res;
      console.log("data", res);
      if (status) {
        Swal.fire("Rejected!", "Quotation has been Rejected", "success");
        navigate(-1);
      } else {
        Swal.fire("Failed!", message, "error");
      }
    } catch (error) {
      Swal.fire("Failed!", "Something went wrong", "error");
      setSignature({
        isActive: false,
        label: "Authorised Signatory",
        image: null,
      });
    }
  };

  const handleCancel = () => {
    setShowActionModelVisible(false);
    setIsModalRejectedVisible(false);
    form.resetFields();
  };

  const handleApprove = async (id: string, files: File[] = []) => {
    try {
      const res = await quotationApis.approve(Number(id), files);
      const { response, status, message } = res;
      console.log("data", res);
      if (status) {
        Swal.fire("Approved!", "Quotation has been Approved", "success");
        navigate(-1);
      } else {
        Swal.fire("Failed!", message, "error");
      }
    } catch (error) {
      Swal.fire("Failed!", "Something went wrong", "error");
      setSignature({
        isActive: false,
        label: "Authorised Signatory",
        image: null,
      });
    }
  };
  // console.clear();

  const downloadPDF = async (doc: any) => {
    try {
      console.log("try");
      if (doc) {
        doc.save(OriginalData?.quotationHeader?.rfqId + ".pdf");
      }
    } catch (error) {
      console.log(error);
    }
  };

  const openApproveConfirmSwal = () => {
    if (!signature.image) return;

    setIsModalApproveVisible(false);

    Swal.fire({
      title: "Are you sure?",
      text: "You will not be able to recover this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Approve it!",
      cancelButtonText: "No, keep it",
      allowOutsideClick: false,
      allowEscapeKey: false,
    }).then(async (result) => {
      if (result.isConfirmed) {
        const file = dataURLToFile(signature.image as string, "signature.png");
        await handleApprove(approveRecord, [file]);
      } else {
        setIsModalApproveVisible(true);
      }
    });
  };

  const openRejectConfirmSwal = async () => {
    try {
      await form.validateFields();

      if (!signature.image) {
        Swal.fire({
          icon: "info",
          title: "Signature Required",
          text: "Please add your signature before rejecting.",
        });
        return;
      }

      setIsModalRejectedVisible(false);

      Swal.fire({
        title: "Confirm Rejection?",
        text: "This action cannot be undone!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, Reject it!",
        cancelButtonText: "Cancel",
        allowOutsideClick: false,
        allowEscapeKey: false,
      }).then(async (result) => {
        if (result.isConfirmed) {
          const values = form.getFieldsValue();
          await apiCallToRejectBudget(rejectRecord, values.reason);
        } else {
          setIsModalRejectedVisible(true);
        }
      });
    } catch (e) {
      console.log("Validation failed:", e);
    }
  };

  return (
    <>
      <Head title="View Quotation Details" />
      <Modal
        isOpen={generalInformationEdit}
        toggle={() => setGeneralInformationEdit(false)}
        className="modal-dialog-centered"
        size="xl"
        backdrop="static"
      >
        <a
          href="#cancel"
          onClick={(ev) => {
            ev.preventDefault();
            setGeneralInformationEdit(false);
          }}
          className="close"
        >
          <Icon name="cross-sm"></Icon>
        </a>

        <ModalBody>
          <>
            <h5 className="title">Update General Information</h5>
            <div style={{ marginTop: "15px" }}></div>

            <FormProvider {...methods}>
              <form
                className="content clearfix"
                onSubmit={handleSubmit((data) => {
                  console.log("data", data);
                  setMaterialData((pre: any) => {
                    // console.log("pre", pre)
                    let billingAddressDetails: any = billingAddressList?.find(
                      (item: any) => item.id == data?.billingAddress
                    );

                    let deliveryAddressDetails = deliveryAddressList.find(
                      (item: any) => item.id == data?.deliveryAddressId
                    );
                    console.log("DATA:::", billingAddressDetails);
                    
                    // Convert preferredBrands from array of IDs to array of objects
                    let preferredBrandsFormatted: any[] = [];
                    if (Array.isArray(data.preferredBrands) && data.preferredBrands.length > 0) {
                      preferredBrandsFormatted = data.preferredBrands.map((brandId: string) => {
                        const brand = brandOptions.find((opt) => opt.value === brandId);
                        return {
                          brandId: brandId,
                          brandName: brand?.label || "",
                        };
                      });
                    } else if (data.preferredBrands && typeof data.preferredBrands === "string" && data.preferredBrands.trim() !== "") {
                      // Handle legacy string format - convert to empty array as we're moving to new format
                      preferredBrandsFormatted = [];
                    }
                    // If data.preferredBrands is undefined, null, empty string, or empty array, preferredBrandsFormatted remains []
                    
                    // return
                    const newQuotationHeader = {
                      ...pre.quotationHeader, // Keep existing values
                      ...data,
                      lastSubmissionDate: dayjs(data.lastSubmissionDate).format(
                        "DD-MMM-YYYY HH:mm:ss"
                      ),
                      deliveryDate: dayjs(data.needByDate).format(
                        "DD-MMM-YYYY"
                      ),
                      deliveryDateType: data.deliveryDateType,
                      expectedCreditDays: data.expectedCreditDays,
                      preferredBrands: preferredBrandsFormatted,
                      paymentTerms: data.paymentTerms,
                      isSealedBid: data.isSealedBid === "Y" ? true : false,
                      sealedBidSubmissionDate:
                        data.isSealedBid === "Y" && data.sealedBidSubmissionDate
                          ? dayjs(data.sealedBidSubmissionDate).format("YYYY-MM-DD HH:mm:ss")
                          : null,
                      postalAddress:
                        data.isSealedBid === "Y" ? data.postalAddress || null : null,
                      isStrictEvaluationTimer: data.isStrictEvaluationTimer === "Y" ? true : false,
                      evaluationDate:
                        data.isStrictEvaluationTimer === "Y" && data.evaluationDate
                          ? dayjs(data.evaluationDate).format("YYYY-MM-DD HH:mm:ss")
                          : null,
                      billingAddressId: data?.billingAddress,
                      deliveryAddressId: data?.deliveryAddressId,
                      billingAddressName: {
                        deliveryLocationName: billingAddressOptions.find(
                          (item) => item.value == data?.billingAddress
                        )?.label,
                        addressLine1: billingAddressDetails.addressLine1,
                        addressLine2: billingAddressDetails.addressLine2,
                        city: billingAddressDetails.city,
                        district: {
                          districtName: billingAddressDetails.districtName,
                        },
                        state: {
                          stateName: billingAddressDetails.stateName,
                        },
                        countryInfo: {
                          countryName: billingAddressDetails.countryName,
                        },
                        pincode: billingAddressDetails.pincode,
                      },
                      deliveryAddressName: {
                        deliveryLocationName: deliveryAddressOptions.find(
                          (item) => item.value == data?.deliveryAddressId
                        )?.label,
                        addressLine1: deliveryAddressDetails?.addressLine1,
                        addressLine2: deliveryAddressDetails?.addressLine2,
                        city: deliveryAddressDetails?.city,
                        district: {
                          districtName: deliveryAddressDetails?.districtName,
                        },
                        state: {
                          stateName: deliveryAddressDetails?.stateName,
                        },
                        countryInfo: {
                          countryName: deliveryAddressDetails?.countryName,
                        },
                        pincode: deliveryAddressDetails?.pincode,
                      },
                      siteName: sitesOptions.find(
                        (item) => item.value == data?.siteId
                      )?.label,
                      costCenterName: costCenterOptions.find(
                        (item) => item.value == data?.costCenter
                      )?.label,
                      contractorName: contractorOptions.find(
                        (item) => item.value == data?.contractorId
                      )?.label,
                    };

                    console.log("updatedData", newQuotationHeader);

                    const updatedMaterialData = {
                      ...pre, // Keep existing data
                      quotationHeader: newQuotationHeader, // Update quotationHeader
                    };

                    return {
                      ...pre,
                      ...data,
                      ...updatedMaterialData,
                    };
                  });
                  setGeneralInformationEdit(false);
                  setAddNewRowModel(false);
                  setEditLineRow(null);
                  console.log("setMaterialData", materialData);
                  setShowSubmitBtm(true);
                })}
              >
                <Row className="gy-4">
                  <Col lg="4">
                    <FormSelect
                      name="quotationFor"
                      label="Quotation For"
                      options={[
                        { label: "Material", value: "Material" },
                        { label: "Service", value: "Service" },
                      ]}
                      required={true}
                      placeholder="Select Quotation Type"
                    />
                  </Col>
                  <Col lg="4">
                    <FormMultiSelect
                      name="preferredBrands"
                      label="Preferred Brands / Make"
                      options={brandOptions}
                      placeholder="Select Preferred Brands / Make"
                    />
                  </Col>
                  <Col lg="4">
                    <FormInput
                      name="quotationDescription"
                      label="Quotation Description"
                      required={true}
                      type="text"
                      minLength={2}
                      maxLength={100}
                      placeholder="Enter Description"
                    />
                  </Col>
                </Row>
                <Row className="gy-4 mt-1">
                  <Col lg="4">
                    <FormSelect
                      name="costCenter"
                      label="Cost Center"
                      options={costCenterOptions}
                      // required={true}
                      placeholder="Select Cost Center"
                    />
                  </Col>
                  <Col lg="4">
                    <FormDatePicker
                      name="lastSubmissionDate"
                      label="Last Submission Date & Time"
                      required={true}
                      placeholder="Select Date & Time"
                      minDate={new Date()}
                      showTime={true}
                      dateFormat="DD-MMM-YYYY hh:mm A"
                    />
                  </Col>
                  <Col lg="4">
                    <FormSelect
                      name="deadlineType"
                      label="Time limit"
                      options={[
                        { label: "Soft", value: "SOFT" },
                        { label: "Hard", value: "HARD" },
                      ]}
                      required={true}
                      placeholder="Select"
                    />
                  </Col>
                </Row>
                <Row className="gy-4 mt-1">
                  <Col lg="4">
                    <FormSelect
                      name="siteId"
                      label="Site Name"
                      options={sitesOptions}
                      required={true}
                      placeholder="Select"
                      disabled={
                        OriginalData?.quotationHeader?.prIds?.length > 0
                          ? true
                          : false
                      }
                    />
                  </Col>
                  <Col lg="4">
                    <FormSelect
                      name="contractorId"
                      label={`Contractor`}
                      required={true}
                      options={contractorOptions}
                      placeholder="-Select-"
                      tooltipText="Select the contractor for this purchase order."
                    />
                  </Col>
                  <Col lg="4">
                    <FormSelect
                      name="additionalCharges"
                      label="Additional Charges?"
                      options={[
                        { label: "Fixed", value: "Fixed" },
                        { label: "Flexible", value: "Flexible" },
                      ]}
                      required={true}
                      placeholder="Select"
                    />
                  </Col>
                </Row>
                <Row className="mt-4">
                  <Col lg="4">
                    <FormSelect
                      name="autoRelease"
                      label="Auto Release"
                      defaultValue={{
                        label: "Yes",
                        value: "Y",
                      }}
                      options={[
                        { label: "Yes", value: "Y" },
                        { label: "No", value: "N" },
                      ]}
                      required={true}
                      placeholder="Select"
                    />
                  </Col>
                  <Col lg="4">
                    <FormSelect
                      name="pricingMode"
                      label="Pricing Mode"
                      options={[
                        { label: "Base Price", value: "Base Price" },
                        { label: "MRP", value: "MRP" },
                      ]}
                      required={true}
                      placeholder="Select"
                    />
                  </Col>
                  <Col lg="4">
                    <FormSelect
                      name="billingAddress"
                      label="Billing Address"
                      options={billingAddressOptions}
                      required={true}
                      placeholder="Select"
                    //   onChange={onBillingAddressChange}
                    />
                    {/* {formState.selectedBillingAddress && (
                                            <Popover content={(
                                                <ul>
                                                    <li>{formState.selectedBillingAddress.addressLine1} {formState.selectedBillingAddress.addressLine2}</li>
                                                    <li>{formState.selectedBillingAddress.cityName}, {formState.selectedBillingAddress.stateName}, {formState.selectedBillingAddress.countryName} - {formState.selectedBillingAddress.pincode}</li>
                                                </ul>
                                            )} title="Selected Address">
                                                <a>View Selected Billing Address</a>
                                            </Popover>
                                        )} */}
                  </Col>
                  <Col lg="4">
                    <FormSelect
                      name="deliveryLevelType"
                      label="Delivery Address at"
                      options={[
                        { label: "Order Level", value: "ORDER_LEVEL" },
                        { label: "Line Level", value: "LINE_LEVEL" },
                      ]}
                      required={true}
                      placeholder="Select"
                      disabled={
                        OriginalData?.quotationHeader?.prIds?.length > 0
                          ? true
                          : false
                      }
                    //   onChange={handleDeliveryAddressTypeChange}
                    />
                  </Col>
                </Row>
                <Row className="mt-4">
                  {deliveryLevelTypeWatch === "ORDER_LEVEL" && (
                    <>
                      <Col lg="4">
                        <FormSelect
                          name="deliveryAddressId"
                          label="Delivery Address"
                          options={deliveryAddressOptions}
                          required={true}
                          placeholder={
                            siteIdWatch ? "-Select-" : "Select a site first"
                          }
                          disabled={
                            OriginalData?.quotationHeader?.prIds?.length > 0
                              ? true
                              : false
                          }
                        // onChange={handleDeliveryAddressChange}
                        />
                        {/* {formState.selectedDeliveryAddress && (
                                                <Popover content={(
                                                    <ul>
                                                        <li>{formState.selectedDeliveryAddress.addressLine1} {formState.selectedDeliveryAddress.addressLine2}</li>
                                                        <li>{formState.selectedDeliveryAddress.cityName}, {formState.selectedDeliveryAddress.stateName}, {formState.selectedDeliveryAddress.countryName} - {formState.selectedDeliveryAddress.pincode}</li>
                                                    </ul>
                                                )} title="Selected Address">
                                                    <a>View Selected Delivery Address</a>
                                                </Popover>
                                            )} */}
                      </Col>
                    </>
                  )}
                  <Col lg="4">
                    <FormSelect
                      name="deliveryDateType"
                      label="Multiple Delivery Dates ?"
                      options={[
                        { label: "Yes", value: "LINE_LEVEL" },
                        { label: "No", value: "ORDER_LEVEL" },
                      ]}
                      placeholder="-Select-"
                      // tooltipText="delivery date will be based on the line level. If you select 'No' then delivery date will be based on the Order Level."
                      required={true}
                    />
                  </Col>

                  {deliveryDateTypeWatch === "ORDER_LEVEL" && (
                    <Col lg="4">
                      <FormDatePicker
                        name="needByDate"
                        label="Need By Date"
                        required={true}
                        placeholder="Select Date"
                        minDate={new Date()}
                      />
                    </Col>
                  )}
                </Row>
                <Row className="mt-4">
                  <Col lg="4">
                    <FormSelect
                      name="paymentTerms"
                      label="Payment Terms"
                      options={[
                        { label: "Cash & Carry", value: "Cash and Carry" },
                        // { label: "Advance", value: "Advance" },
                        { label: "Credit", value: "Credit" },
                      ]}
                      required={true}
                      placeholder="Select Payment Terms"
                    />
                  </Col>

                  {paymentTermsWatch == "Credit" && (
                    <Col lg="4">
                      <FormInput
                        name="expectedCreditDays"
                        type="number"
                        label="Credit Days"
                        required={true}
                        placeholder="Enter Credit Days"
                      />
                    </Col>
                  )}
                </Row>
                {isSealedBidWatch === "Y" && (
                  <Row className="mt-4">
                    <Col lg="4">
                      <FormDatePicker
                        name="sealedBidSubmissionDate"
                        label="Sealed Bid Submission Date & Time"
                        required={true}
                        placeholder="Select Date & Time"
                        showTime={true}
                        dateFormat="DD-MMM-YYYY hh:mm A"
                        disabledDate={(current: any) => {
                          if (!current) return false;
                          const lastSubDate = watch("lastSubmissionDate");
                          const originalDate = materialData?.quotationHeader?.sealedBidSubmissionDate;
                          // Use the later of lastSubmissionDate and original value as minimum
                          let minDate = lastSubDate ? dayjs(lastSubDate) : dayjs();
                          if (originalDate) {
                            const origDayjs = dayjs.utc(originalDate);
                            if (origDayjs.isAfter(minDate)) minDate = origDayjs;
                          }
                          return current.isBefore(minDate, "day");
                        }}
                        disabledTime={(current: any) => {
                          const lastSubDate = watch("lastSubmissionDate");
                          const originalDate = materialData?.quotationHeader?.sealedBidSubmissionDate;
                          if (!current) return {};
                          // Use the later of lastSubmissionDate and original value as minimum
                          let ref = lastSubDate ? dayjs(lastSubDate) : null;
                          if (originalDate) {
                            const origDayjs = dayjs.utc(originalDate);
                            if (!ref || origDayjs.isAfter(ref)) ref = origDayjs;
                          }
                          if (!ref) return {};
                          if (!current.isSame(ref, "day")) return {};
                          const refHour = ref.hour();
                          const refMinute = ref.minute();
                          return {
                            disabledHours: () =>
                              Array.from({ length: 24 }, (_, i) => i).filter(
                                (h) => h < refHour
                              ),
                            disabledMinutes: (selectedHour: number) => {
                              if (selectedHour < refHour) return Array.from({ length: 60 }, (_, i) => i);
                              if (selectedHour === refHour)
                                return Array.from({ length: 60 }, (_, i) => i).filter(
                                  (m) => m < refMinute
                                );
                              return [];
                            },
                          };
                        }}
                        customValidation={{
                          validate: (value: any) => {
                            if (!value) return true;
                            const lastSubDate = watch("lastSubmissionDate");
                            if (lastSubDate && dayjs(value).isBefore(dayjs(lastSubDate))) {
                              return "Must be on or after Last Submission Date & Time";
                            }
                            const originalDate = materialData?.quotationHeader?.sealedBidSubmissionDate;
                            if (originalDate && dayjs(value).isBefore(dayjs.utc(originalDate))) {
                              return "Cannot be earlier than the existing date & time";
                            }
                            return true;
                          },
                        }}
                      />
                    </Col>
                    <Col lg="4">
                      <FormInput
                        name="postalAddress"
                        label="Postal Address"
                        required={true}
                        type="text"
                        placeholder="Enter Postal Address"
                      />
                    </Col>
                  </Row>
                )}
                {isStrictEvaluationTimerWatch === "Y" && (
                  <Row className="mt-4">
                    <Col lg="4">
                      <FormDatePicker
                        name="evaluationDate"
                        label="Evaluation Date & Time"
                        required={true}
                        placeholder="Select Date & Time"
                        showTime={true}
                        dateFormat="DD-MMM-YYYY hh:mm A"
                        disabledDate={(current: any) => {
                          if (!current) return false;
                          const sealedBidDate = watch("sealedBidSubmissionDate");
                          const originalDate = materialData?.quotationHeader?.evaluationDate;
                          // Use the later of sealedBidDate and original value as minimum
                          let minDate = sealedBidDate ? dayjs(sealedBidDate) : dayjs();
                          if (originalDate) {
                            const origDayjs = dayjs.utc(originalDate);
                            if (origDayjs.isAfter(minDate)) minDate = origDayjs;
                          }
                          return current.isBefore(minDate, "day");
                        }}
                        disabledTime={(current: any) => {
                          const sealedBidDate = watch("sealedBidSubmissionDate");
                          const originalDate = materialData?.quotationHeader?.evaluationDate;
                          if (!current) return {};
                          // Use the later of sealedBidDate and original value as minimum
                          let ref = sealedBidDate ? dayjs(sealedBidDate) : null;
                          if (originalDate) {
                            const origDayjs = dayjs.utc(originalDate);
                            if (!ref || origDayjs.isAfter(ref)) ref = origDayjs;
                          }
                          if (!ref) return {};
                          if (!current.isSame(ref, "day")) return {};
                          const refHour = ref.hour();
                          const refMinute = ref.minute();
                          return {
                            disabledHours: () =>
                              Array.from({ length: 24 }, (_, i) => i).filter(
                                (h) => h < refHour
                              ),
                            disabledMinutes: (selectedHour: number) => {
                              if (selectedHour < refHour) return Array.from({ length: 60 }, (_, i) => i);
                              if (selectedHour === refHour)
                                return Array.from({ length: 60 }, (_, i) => i).filter(
                                  (m) => m < refMinute
                                );
                              return [];
                            },
                          };
                        }}
                        customValidation={{
                          validate: (value: any) => {
                            if (!value) return true;
                            const sealedBidDate = watch("sealedBidSubmissionDate");
                            if (sealedBidDate && dayjs(value).isBefore(dayjs(sealedBidDate))) {
                              return "Must be on or after Sealed Bid Submission Date & Time";
                            }
                            const originalDate = materialData?.quotationHeader?.evaluationDate;
                            if (originalDate && dayjs(value).isBefore(dayjs.utc(originalDate))) {
                              return "Cannot be earlier than the existing date & time";
                            }
                            return true;
                          },
                        }}
                      />
                    </Col>
                  </Row>
                )}
                <Row className="mt-4">
                  <Col lg="12">
                    <ul className="align-center flex-wrap flex-sm-nowrap gx-4 gy-2">
                      <li>
                        <Button
                          className="btn btn-primary btn-md"
                          type="submit"
                          color="primary"
                        >
                          Save
                        </Button>
                      </li>
                      <li>
                        <a
                          href="#cancel"
                          onClick={(ev) => {
                            ev.preventDefault();
                            setGeneralInformationEdit(false);
                            reset();
                          }}
                          className="link link-light"
                        >
                          Cancel
                        </a>
                      </li>
                    </ul>
                  </Col>
                </Row>
              </form>
            </FormProvider>
          </>
        </ModalBody>
      </Modal>
      <Content>
        <Card className="card-bordered">
          <div className="card-aside-wrap">
            {isLoading == true ? (
              <>
                <Flex align="center" gap="middle" className="pageLoader">
                  <Spin size="large" className="m-auto" />
                </Flex>
              </>
            ) : (
              <div className="card-inner card-inner-lg">
                {sm && mobileView && (
                  <div
                    className="toggle-overlay"
                    onClick={() => setSm(!sm)}
                  ></div>
                )}
                <BlockHead size="lg">
                  <BlockBetween>
                    <BlockHeadContent>
                      <BlockTitle tag="h4">
                        <span>
                          RFQ - {OriginalData?.quotationHeader?.rfqId} |{" "}
                          {(statusMapper[rfqStatus] &&
                            statusMapper[rfqStatus]?.buyer?.title) ||
                            rfqStatus}{" "}
                        </span>
                      </BlockTitle>
                    </BlockHeadContent>
                    <div className="d-flex">
                      {/* {materialData?.quotationHeader?.status?.toLowerCase() === "pending" &&
                        screenNavigationStatus == "Pending RFQ Approvals" && !hasUserAlreadyApproved && (
                          <>
                            {canUserApproveReject() ? (
                              <>
                                <Button
                                  size="sm"
                                  color="success"
                                  className="mx-1"
                                  onClick={() => {
                                    setApproveRecord(materialData?.quotationHeader?.quotationId);
                                    setActiveSignatureContext("APPROVE");
                                    setIsModalApproveVisible(true);
                                  }}
                                >
                                  <Icon name="check" title="Approve" /> Approve
                                </Button>

                                <Button
                                  size="sm"
                                  color="danger"
                                  onClick={() => {
                                    setRejectRecord(materialData?.quotationHeader?.quotationId);
                                    setActiveSignatureContext("REJECT");
                                    setIsModalRejectedVisible(true);
                                  }}
                                >
                                  <Icon name="cross" title="Reject" /> Reject
                                </Button>
                              </>
                            ) : (
                              <div className="d-flex align-items-center" style={{ gap: "8px" }}>
                                <Button
                                  size="sm"
                                  color="secondary"
                                  className="mx-1"
                                  disabled
                                  style={{ cursor: "not-allowed", opacity: 0.6 }}
                                >
                                  <Icon name="check" /> Approve
                                </Button>

                                <Button
                                  size="sm"
                                  color="secondary"
                                  className="mx-1"
                                  disabled
                                  style={{ cursor: "not-allowed", opacity: 0.6 }}
                                >
                                  <Icon name="cross" /> Reject
                                </Button>

                                <Popover
                                  content={
                                    <div style={{ padding: "8px", maxWidth: "300px" }}>
                                      <p style={{ margin: 0 }}>{getPendingStatusMessage()}</p>
                                    </div>
                                  }
                                  title="Approval Status"
                                  trigger="hover"
                                >
                                  <InfoCircleOutlined
                                    style={{
                                      // color: "#faad14",
                                      fontSize: "20px",
                                      cursor: "pointer"
                                    }}
                                  />
                                </Popover>
                              </div>
                            )}
                          </>
                        )} */}

                      {showSubmitBtm && (
                        <div className="actions clearfix">
                          <ul
                            className="m-auto d-flex align-items-center justify-content-center p-0"
                            style={{
                              flexDirection: "row-reverse",
                            }}
                          >
                            {rfqStatus == "Draft" && (
                              <li className="pt-0 pb-0">
                                {disableDraft ? (
                                  <Button color="primary" type="button">
                                    <Spinner size="sm" color="light" />
                                  </Button>
                                ) : (
                                  <Button
                                    color="primary"
                                    type="button"
                                    onClick={() => {
                                      setDisableDraft(true);
                                      Swal.fire({
                                        title: "Are you sure?",
                                        text: "Do you want to save the changes as draft?",
                                        icon: "warning",
                                        showCancelButton: true,
                                        confirmButtonColor: "#3085d6",
                                        cancelButtonColor: "#d33",
                                        confirmButtonText: "Yes, save it!",
                                        cancelButtonText: "No, cancel",
                                      }).then(async (result) => {
                                        if (result.isConfirmed) {
                                          await SubmitChanges("DRAFT");
                                        } else {
                                          setDisableDraft(false);
                                        }
                                      });
                                    }}
                                  >
                                    Save Draft
                                  </Button>
                                )}
                              </li>
                            )}
                            <li className="pt-0 pb-0">
                              {disableSubmit ? (
                                <Button color="primary" type="button">
                                  <Spinner size="sm" color="light" />
                                </Button>
                              ) : (
                                <Button
                                  color="primary"
                                  type="button"
                                  onClick={() => {
                                    setDisableSubmit(true);
                                    Swal.fire({
                                      title: "Are you sure?",
                                      text: "Do you want to submit the changes?",
                                      icon: "warning",
                                      showCancelButton: true,
                                      confirmButtonColor: "#3085d6",
                                      cancelButtonColor: "#d33",
                                      confirmButtonText: "Yes, submit it!",
                                      cancelButtonText: "No, cancel",
                                    }).then(async (result) => {
                                      if (result.isConfirmed) {
                                        await SubmitChanges("SUBMIT");
                                      } else {
                                        setDisableSubmit(false);
                                      }
                                    });
                                  }}
                                >
                                  Save Changes
                                </Button>
                              )}
                            </li>
                            <li className="pt-0 pb-0">
                              <Button
                                color="secondary"
                                onClick={() => {
                                  Swal.fire({
                                    title: "Are you sure?",
                                    text: "Do you want to revert the changes?",
                                    icon: "warning",
                                    showCancelButton: true,
                                    confirmButtonColor: "#3085d6",
                                    cancelButtonColor: "#d33",
                                    confirmButtonText: "Yes, revert it!",
                                    cancelButtonText: "No, cancel",
                                  }).then((result) => {
                                    if (result.isConfirmed) {
                                      fetchDetails();
                                      Swal.fire(
                                        "Reverted!",
                                        "Your changes have been reverted.",
                                        "success"
                                      );
                                    }
                                  });
                                }}
                                type="button"
                                className="btn-dim btn btn-secondary"
                              >
                                Revert Changes
                              </Button>
                            </li>
                          </ul>
                        </div>
                      )}
                      {rfqStatus == "Draft" && !showSubmitBtm && (
                        <div className="paddingLeft10">
                          {disableSubmit ? (
                            <Button color="primary" type="button">
                              <Spinner size="sm" color="light" />
                            </Button>
                          ) : (
                            <Button
                              className="toggle"
                              color="primary"
                              onClick={() => {
                                setDisableSubmit(true);
                                Swal.fire({
                                  title: "Are you sure?",
                                  text: "Do you want to submit?",
                                  icon: "warning",
                                  showCancelButton: true,
                                  confirmButtonColor: "#3085d6",
                                  cancelButtonColor: "#d33",
                                  confirmButtonText: "Yes, submit it!",
                                  cancelButtonText: "No, cancel",
                                }).then(async (result) => {
                                  if (result.isConfirmed) {
                                    await SubmitChanges("SUBMIT");
                                  } else {
                                    setDisableSubmit(false);
                                  }
                                });
                              }}
                            >
                              <span>Submit</span>
                            </Button>
                          )}
                        </div>
                      )}

                      {!showSubmitBtm && (
                        <div className="paddingLeft10">
                          <Button
                            type="button"
                            color=""
                            onClick={async () => {
                              const { pdfUrl, pdfBlob, doc }: any =
                                await PdfGenerator(
                                  returnBillingDetails(OriginalData),
                                  returnSupplierDetails(OriginalData),
                                  returnDetails(data),
                                  currentUser?.orgLogo,
                                  false,
                                  termsAndConditions,
                                  OriginalData?.quotationApprovals || []
                                );
                              console.clear();
                              console.log("pdfUrl", pdfUrl);

                              setPdfBlobData({
                                current: pdfBlob,
                                url: pdfUrl,
                                doc,
                              });
                              setShowPdfModal(true);
                            }}
                          >
                            PDF <Icon name="file-pdf" />
                          </Button>
                        </div>
                      )}
                      <li className="pt-0 pb-0 p-2">
                        <Dropdown
                          isOpen={shareOptionsToggle}
                          toggle={() => {
                            setShareOptionsToggle(!shareOptionsToggle);
                          }}
                        >
                          <DropdownToggle className="btn btn-white btn-outline-light">
                            <Icon name="share"></Icon>
                            <span>Send</span>
                          </DropdownToggle>
                          <DropdownMenu>
                            {/* <DropdownItem onClick={() => {}}>
                                    <Icon name="archive"></Icon>
                                    <span>Send SMS</span>
                                  </DropdownItem> */}
                            <DropdownItem
                              onClick={() => {
                                setShowEmailModal(true);
                              }}
                            >
                              <Icon name="mail"></Icon>
                              <span>Send Mail</span>
                            </DropdownItem>
                          </DropdownMenu>
                        </Dropdown>
                      </li>

                      {OriginalData?.quotationHeader?.version > 1 ? (
                        <li className="pt-0 pb-0">
                          <Button
                            color="primary"
                            type="button"
                            onClick={() => {
                              navigate("/viewhistory", {
                                state: {
                                  rfqId: OriginalData?.quotationHeader?.rfqId,
                                },
                              });
                            }}
                          >
                            Version History
                          </Button>
                        </li>
                      ) : (
                        <></>
                      )}

                      {!showSubmitBtm && (
                        <div className="paddingLeft10">
                          <Button
                            className="toggle"
                            color="primary"
                            onClick={async () => {
                              navigate(-1);
                            }}
                          >
                            <Icon name="arrow-left" />
                            <span>Back</span>
                          </Button>
                        </div>
                      )}
                      {materialData?.quotationHeader?.status?.toLowerCase() === "pending" &&
                        !hasUserAlreadyApproved && (
                      <ul className="nk-tb-actions ms-2">
                        <li>
                          <UncontrolledDropdown>
                            <DropdownToggle
                              tag="a"
                              className="dropdown-toggle btn btn-icon btn-trigger"
                            >
                              <Icon name="more-v"></Icon>
                            </DropdownToggle>
                            <DropdownMenu end>
                              <ul className="link-list-opt no-bdr">
                                {materialData?.quotationHeader?.status?.toLowerCase() === "pending" &&
                                  !hasUserAlreadyApproved && (
                                    <>
                                      {canUserApproveReject() ? (
                                        <>
                                          <li
                                            onClick={(e) => {
                                              e.preventDefault();
                                              setApproveRecord(materialData?.quotationHeader?.quotationId);
                                              setActiveSignatureContext("APPROVE");
                                              setIsModalApproveVisible(true);
                                              const dropdown = document.querySelector(
                                                ".dropdown-menu.show"
                                              );
                                              if (dropdown) {
                                                dropdown.classList.remove("show");
                                              }
                                            }}
                                          >
                                            <Link to={`#`}>
                                              <Icon name="check" /> Approve
                                            </Link>
                                          </li>
                                          <li
                                            onClick={(e) => {
                                              e.preventDefault();
                                              setRejectRecord(materialData?.quotationHeader?.quotationId);
                                              setActiveSignatureContext("REJECT");
                                              setIsModalRejectedVisible(true);
                                              const dropdown = document.querySelector(
                                                ".dropdown-menu.show"
                                              );
                                              if (dropdown) {
                                                dropdown.classList.remove("show");
                                              }
                                            }}
                                          >
                                            <Link to={`#`}>
                                              <Icon name="cross" /> Reject
                                            </Link>
                                          </li>
                                        </>
                                      ) : (
                                        <><li className="disabled" style={{ position: 'relative' }}>
                                          <div
                                            className="d-flex align-items-center justify-content-between w-100"
                                            style={{
                                              padding: "8px 16px",
                                              opacity: 0.6,
                                              cursor: "not-allowed",
                                            }}
                                          >
                                            <div className="d-flex align-items-center" style={{ gap: "8px" }}>
                                              <Icon name="check" />
                                              <span>Approve</span>
                                            </div>
                                            <Popover
                                              content={
                                                <div style={{ padding: "8px", maxWidth: "300px" }}>
                                                  <p style={{ margin: 0 }}>{getPendingStatusMessage()}</p>
                                                </div>
                                              }
                                              title="Approval Status"
                                              trigger="hover"
                                            >
                                              <InfoCircleOutlined
                                                style={{
                                                  fontSize: "16px",
                                                  cursor: "pointer",
                                                  color: "#2263b3",
                                                  marginLeft: "8px"
                                                }}
                                              />
                                            </Popover>
                                          </div>
                                        </li>
                                          <li className="disabled">
                                            <div
                                              className="d-flex align-items-center"
                                              style={{
                                                padding: "8px 16px",
                                                opacity: 0.6,
                                                cursor: "not-allowed",
                                                gap: "8px"
                                              }}
                                            >
                                              <Icon name="cross" />
                                              <span>Reject</span>
                                            </div>
                                          </li>
                                        </>
                                      )}
                                    </>
                                  )}
                              </ul>
                            </DropdownMenu>
                          </UncontrolledDropdown>
                        </li>
                      </ul>
                      )}
                    </div>
                    <BlockHeadContent className="align-self-start d-lg-none">
                      <Button
                        className={`toggle btn btn-icon btn-trigger mt-n1 ${sm ? "active" : ""
                          }`}
                        onClick={() => setSm(!sm)}
                      >
                        <Icon name="menu-alt-r" />
                      </Button>
                    </BlockHeadContent>
                  </BlockBetween>
                </BlockHead>
                <div className="content clearfix">
                  <AntCollapse defaultActiveKey={["1", "2", "3"]}>
                    <Panel
                      header={
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            width: "100%",
                          }}
                        >
                          <span>General Details</span>
                          {/* {rfqStatus} */}
                          {!["Awarded", "Negotiated", "Quoted"].includes(
                            rfqStatus
                          ) && (
                              <span
                                className="cursor-pointer position-absolute"
                                style={{
                                  right: 20,
                                  top: 10,
                                  fontSize: "18px",
                                  cursor: "pointer",
                                }}
                                onClick={(e) => {
                                  setValue(
                                    "quotationFor",
                                    materialData?.quotationHeader.quotationFor
                                  );
                                  // Convert preferredBrands array of objects to array of IDs for multi-select
                                  const preferredBrandsValue = materialData?.quotationHeader.preferredBrands;
                                  if (Array.isArray(preferredBrandsValue) && preferredBrandsValue.length > 0) {
                                    if (typeof preferredBrandsValue[0] === "object" && preferredBrandsValue[0].brandId) {
                                      const brandIds = preferredBrandsValue.map((brand: any) => brand.brandId?.toString() || brand.id?.toString());
                                      setValue("preferredBrands", brandIds);
                                    } else {
                                      setValue("preferredBrands", preferredBrandsValue);
                                    }
                                  } else {
                                    setValue("preferredBrands", []);
                                  }
                                  setValue(
                                    "paymentTerms",
                                    materialData?.quotationHeader.paymentTerms
                                  );
                                  setValue(
                                    "quotationDescription",
                                    materialData?.quotationHeader
                                      .quotationDescription
                                  );
                                  setValue(
                                    "costCenter",
                                    materialData?.quotationHeader?.costCenter
                                  );
                                  setValue(
                                    "contractorId",
                                    materialData?.quotationHeader?.contractorId
                                  );
                                  setValue(
                                    "lastSubmissionDate",
                                    dayjs.utc(
                                      materialData?.quotationHeader
                                        ?.lastSubmissionDate
                                    )
                                  );
                                  setValue(
                                    "deadlineType",
                                    materialData?.quotationHeader?.deadlineType
                                  );
                                  setValue(
                                    "additionalCharges",
                                    materialData?.quotationHeader
                                      ?.additionalCharges
                                  );
                                  setValue(
                                    "autoRelease",
                                    materialData?.quotationHeader?.autoRelease
                                  );
                                  setValue(
                                    "pricingMode",
                                    materialData?.quotationHeader?.pricingMode ||
                                    "Base Price"
                                  );
                                  setValue(
                                    "billingAddress",
                                    materialData?.quotationHeader
                                      ?.billingAddressId
                                  );
                                  setValue(
                                    "expectedCreditDays",
                                    materialData?.quotationHeader
                                      ?.expectedCreditDays
                                  );
                                  setValue(
                                    "deliveryLevelType",
                                    materialData?.quotationHeader
                                      ?.deliveryLevelType
                                  );
                                  setValue(
                                    "deliveryDateType",
                                    materialData?.quotationHeader
                                      ?.deliveryDateType
                                  );
                                  setValue(
                                    "deliveryAddressId",
                                    materialData?.quotationHeader
                                      ?.deliveryAddressId
                                  );
                                  setValue(
                                    "siteId",
                                    materialData?.quotationHeader?.siteId
                                  );
                                  setValue(
                                    "needByDate",
                                    dayjs(
                                      materialData?.quotationHeader?.deliveryDate
                                    )
                                  );
                                  setValue(
                                    "isSealedBid",
                                    materialData?.quotationHeader?.isSealedBid === true || materialData?.quotationHeader?.isSealedBid === "Y" ? "Y" : "N"
                                  );
                                  setValue(
                                    "isStrictEvaluationTimer",
                                    materialData?.quotationHeader?.isStrictEvaluationTimer === true || materialData?.quotationHeader?.isStrictEvaluationTimer === "Y" ? "Y" : "N"
                                  );
                                  if (materialData?.quotationHeader?.sealedBidSubmissionDate) {
                                    setValue(
                                      "sealedBidSubmissionDate",
                                      dayjs.utc(materialData?.quotationHeader?.sealedBidSubmissionDate)
                                    );
                                  }
                                  setValue(
                                    "postalAddress",
                                    materialData?.quotationHeader?.postalAddress || ""
                                  );
                                  if (materialData?.quotationHeader?.evaluationDate) {
                                    setValue(
                                      "evaluationDate",
                                      dayjs.utc(materialData?.quotationHeader?.evaluationDate)
                                    );
                                  }
                                  setGeneralInformationEdit(true);
                                  e.stopPropagation();
                                }}
                              >
                                <Icon name="edit" />
                              </span>
                            )}
                        </div>
                      }
                      key="1"
                    >
                      <Descriptions
                        title=""
                        className="custom-description-title"
                      >
                        <Descriptions.Item label="Quotation For">
                          {materialData?.quotationHeader?.quotationFor}
                        </Descriptions.Item>
                        <Descriptions.Item label="Preferred Brands / Make">
                          {materialData?.quotationHeader?.preferredBrands && Array.isArray(materialData?.quotationHeader?.preferredBrands) && materialData?.quotationHeader?.preferredBrands.length > 0
                            ? materialData.quotationHeader.preferredBrands.map((brand: any) => 
                                typeof brand === "object" ? brand.brandName : brand
                              ).join(", ")
                            : materialData?.quotationHeader?.preferredBrands || "N/A"}
                        </Descriptions.Item>
                        <Descriptions.Item label="Description">
                          <Popover
                            content={
                              <div>
                                <p>
                                  {
                                    materialData?.quotationHeader
                                      ?.quotationDescription
                                  }
                                </p>
                              </div>
                            }
                            title={"Description"}
                          >
                            {materialData?.quotationHeader?.quotationDescription
                              ?.length > 40 ? (
                              <span
                                style={{
                                  color: "#2263b3",
                                  textDecoration: "underline",
                                  cursor: "pointer",
                                }}
                              >
                                {materialData?.quotationHeader?.quotationDescription?.substring(
                                  0,
                                  40
                                )}
                                ...
                              </span>
                            ) : (
                              materialData?.quotationHeader
                                ?.quotationDescription
                            )}
                          </Popover>
                        </Descriptions.Item>
                        <Descriptions.Item label="Cost Center">
                          {materialData?.quotationHeader?.costCenterName}
                        </Descriptions.Item>
                        <Descriptions.Item label="Last Submission Date & Time">
                          <span className="badge-dim badge bg-primary rounded-pill">
                            <strong>
                              {dayjs.utc(
                                materialData?.quotationHeader
                                  ?.lastSubmissionDate
                              ).format("DD-MMM-YYYY hh:mm A")}
                            </strong>
                          </span>
                        </Descriptions.Item>
                        <Descriptions.Item label="Time Limit">
                          {materialData?.quotationHeader?.deadlineType}
                        </Descriptions.Item>
                        <Descriptions.Item label="Site Name">
                          {materialData?.quotationHeader?.siteName}
                        </Descriptions.Item>
                        <Descriptions.Item label="Contractor">
                          {materialData?.quotationHeader?.contractorName}
                        </Descriptions.Item>
                        <Descriptions.Item
                          label={
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                              }}
                            >
                              Approvals
                              {materialData?.quotationHeader
                                ?.conversionRemarks && (
                                  <Popover
                                    content={
                                      <div style={{ maxWidth: "300px" }}>
                                        <strong>Remarks:</strong>{" "}
                                        {
                                          materialData?.quotationHeader
                                            ?.conversionRemarks
                                        }
                                      </div>
                                    }
                                    title=""
                                  >
                                    <InfoCircleOutlined
                                      style={{
                                        color: "#2263b3",
                                        cursor: "pointer",
                                        fontSize: "12px",
                                      }}
                                    />
                                  </Popover>
                                )}
                            </div>
                          }
                        >
                          {<ApprovalTimelineContent />}
                        </Descriptions.Item>
                        <Descriptions.Item label="Additional Charges">
                          {" "}
                          {materialData?.quotationHeader?.additionalCharges}
                        </Descriptions.Item>
                        <Descriptions.Item label="Auto Release">
                          {materialData?.quotationHeader?.autoRelease === "Y"
                            ? "Yes"
                            : "No"}
                        </Descriptions.Item>
                        <Descriptions.Item label="Pricing Mode">
                          {materialData?.quotationHeader?.pricingMode ||
                            "Base Price"}
                        </Descriptions.Item>
                        <Descriptions.Item label="Billing Address">
                          <Popover
                            content={billingAddressContent}
                            title={
                              <span style={{ color: "#2263b3" }}>
                                Billing Address
                              </span>
                            }
                          >
                            <span
                              style={{
                                color: "#2263b3",
                                textDecoration: "underline",
                                cursor: "pointer",
                              }}
                            >
                              {
                                materialData?.quotationHeader
                                  ?.billingAddressName?.deliveryLocationName
                              }
                            </span>
                          </Popover>
                        </Descriptions.Item>
                        <Descriptions.Item label="Delivery Address Type">
                          {materialData?.quotationHeader?.deliveryLevelType ===
                            "LINE_LEVEL"
                            ? "Line Level"
                            : "Order Level"}
                        </Descriptions.Item>
                        <Descriptions.Item label="Documents Required From Supplier">
                          {materialData?.quotationHeader
                            ?.supplierDocsRequired === "Y" ? (
                            <Popover
                              content={requiredDocsContent}
                              title={
                                <span style={{ color: "#2263b3" }}>
                                  Required Documents
                                </span>
                              }
                            >
                              <span
                                style={{
                                  color: "#2263b3",
                                  textDecoration: "underline",
                                  cursor: "pointer",
                                }}
                              >
                                Yes
                              </span>
                            </Popover>
                          ) : (
                            "No"
                          )}
                        </Descriptions.Item>
                        {materialData?.quotationHeader?.deliveryLevelType ===
                          "ORDER_LEVEL" && (
                            <>
                              <Descriptions.Item label="Delivery Address">
                                <Popover
                                  content={orderDeliveryAddressContent}
                                  title={
                                    <span style={{ color: "#2263b3" }}>
                                      Delivery Address
                                    </span>
                                  }
                                >
                                  <span
                                    style={{
                                      color: "#2263b3",
                                      textDecoration: "underline",
                                      cursor: "pointer",
                                    }}
                                  >
                                    {
                                      materialData?.quotationHeader
                                        ?.deliveryAddressName
                                        ?.deliveryLocationName
                                    }
                                  </span>
                                </Popover>
                              </Descriptions.Item>
                            </>
                          )}
                        <Descriptions.Item label="Multiple Delivery Dates">
                          {materialData?.quotationHeader?.deliveryDateType ===
                            "LINE_LEVEL"
                            ? "Yes"
                            : "No"}
                        </Descriptions.Item>
                        {materialData?.quotationHeader?.deliveryDateType ===
                          "ORDER_LEVEL" && (
                            <Descriptions.Item label="Need By Date">
                              <span className="badge-dim badge bg-primary rounded-pill">
                                <strong>
                                  {dayjs(
                                    materialData?.quotationHeader?.deliveryDate
                                  ).format("DD-MMM-YYYY")}
                                </strong>
                              </span>
                            </Descriptions.Item>
                          )}
                        <Descriptions.Item label="Payment Terms">
                          {materialData?.quotationHeader?.paymentTerms}
                        </Descriptions.Item>
                        {materialData?.quotationHeader?.paymentTerms ==
                          "Credit" && (
                            <>
                              <Descriptions.Item label="Credit Days">
                                {
                                  materialData?.quotationHeader
                                    ?.expectedCreditDays
                                }
                              </Descriptions.Item>
                            </>
                          )}
                        {(materialData?.quotationHeader?.isSealedBid === true || materialData?.quotationHeader?.isSealedBid === "Y") && (
                          <>
                            <Descriptions.Item label="Sealed Bid">
                              <Badge color="outline-success">Yes</Badge>
                            </Descriptions.Item>
                            <Descriptions.Item label="Sealed Bid Submission Date & Time">
                              <span className="badge-dim badge bg-primary rounded-pill">
                                <strong>
                                  {dayjs.utc(
                                    materialData?.quotationHeader?.sealedBidSubmissionDate
                                  ).format("DD-MMM-YYYY hh:mm A")}
                                </strong>
                              </span>
                            </Descriptions.Item>
                            <Descriptions.Item label="Postal Address">
                              {materialData?.quotationHeader?.postalAddress}
                            </Descriptions.Item>
                          </>
                        )}
                        {(materialData?.quotationHeader?.isStrictEvaluationTimer === true || materialData?.quotationHeader?.isStrictEvaluationTimer === "Y") && (
                          <>
                            <Descriptions.Item label="Strict Evaluation Timer">
                              <Badge color="outline-success">Yes</Badge>
                            </Descriptions.Item>
                            <Descriptions.Item label="Evaluation Date & Time">
                              <span className="badge-dim badge bg-primary rounded-pill">
                                <strong>
                                  {dayjs.utc(
                                    materialData?.quotationHeader?.evaluationDate
                                  ).format("DD-MMM-YYYY hh:mm A")}
                                </strong>
                              </span>
                            </Descriptions.Item>
                          </>
                        )}
                      </Descriptions>
                    </Panel>
                    <Panel header="Materials" key="2">
                      <Table
                        columns={filteredColumns?.map((col) => {
                          const { key } = col;
                          if (key == "specification") {
                            col = {
                              ...col,
                              render: (text: any, record: any) => {
                                if (record?.key == "lastRow") {
                                  return (
                                    <b className="justify-end">Total Qty: </b>
                                  );
                                } else {
                                  return text;
                                }
                              },
                              onCell: (record: any) => {
                                if (record?.key == "lastRow") {
                                  return {
                                    colSpan: 5,
                                  };
                                }
                                return {};
                              },
                            };
                          } else if (key == "qty") {
                            col = {
                              ...col,
                              render: (
                                text: any,
                                record: any,
                                index: number
                              ) => {
                                // console.log("record", record, record?.quantity, record?.uom);

                                if (record?.key == "lastRow") {
                                  const total = data?.reduce(
                                    (a: any, b: any) => {
                                      return +a + +b?.quantity;
                                    },
                                    0
                                  );
                                  return (
                                    <div className="justify-end">
                                      {Number(total).toFixed(2)}
                                    </div>
                                  );
                                }
                                return (
                                  <div className="justify-end">
                                    {Number(text).toFixed(2)} {record?.uom}
                                  </div>
                                );
                              },
                            };
                          } else {
                            col = {
                              ...col,
                              onCell: (record: any) => {
                                if (record?.key == "lastRow") {
                                  return {
                                    colSpan: 0,
                                  };
                                }
                                return {};
                              },
                            };
                          }
                          return col;
                        })}
                        dataSource={
                          data?.length > 0
                            ? [
                              ...data.map((item: any, index: any) => ({
                                ...item,
                                key: index,
                              })),
                              {
                                key: "lastRow",
                                materialName: "",
                                quantity: 0,
                                unit: 0,
                                lineTotal: 0,
                              },
                            ]
                            : []
                        }
                        scroll={{ x: 1000 }}
                        expandable={{
                          expandedRowRender: (record: any) => (
                            <div className="expandableBody">
                              {/* {record} */}
                              <div style={{ flex: 1, textAlign: "left" }}>
                                <p style={{ margin: 0 }}>
                                  {record.description}
                                </p>
                                {record.attachment && (
                                  <div>
                                    <PaperClipOutlined /> &nbsp;
                                    {record?.file[0]?.name ? (
                                      <a
                                        href={URL.createObjectURL(
                                          record.file[0]
                                        )}
                                        download={record.file[0]?.name}
                                      >
                                        {record.file[0]?.name}.
                                      </a>
                                    ) : (
                                      <a
                                        href={record?.file?.filePath}
                                        download={record?.file?.filePath}
                                        target="_blank"
                                      >
                                        {record?.file?.fileName}
                                      </a>
                                    )}
                                  </div>
                                )}
                              </div>
                              {materialData?.quotationHeader
                                ?.deliveryLevelType === "LINE_LEVEL" &&
                                record.deliveryAddressName && (
                                  <div
                                    className="lineAddress"
                                    style={{ flex: 1 }}
                                  >
                                    <h6>Delivery Address</h6>
                                    <ul>
                                      <li>
                                        <strong style={{ color: "#2263b3" }}>
                                          {
                                            record?.deliveryAddressName
                                              ?.deliveryLocationName
                                          }
                                        </strong>
                                      </li>
                                      <li>
                                        {
                                          record.deliveryAddressName
                                            .addressLine1
                                        }
                                      </li>
                                      <li>
                                        {
                                          record.deliveryAddressName
                                            .addressLine2
                                        }
                                      </li>
                                      <li>
                                        {record.deliveryAddressName.city},{" "}
                                        {
                                          record.deliveryAddressName.state
                                            .stateName
                                        }
                                        ,{" "}
                                        {
                                          record.deliveryAddressName.countryInfo
                                            .countryName
                                        }{" "}
                                        - {record.deliveryAddressName.pincode}
                                      </li>
                                    </ul>
                                  </div>
                                )}
                            </div>
                          ),
                        }}
                        bordered
                        size="small"
                        pagination={false}
                        locale={{
                          emptyText: (
                            <span
                              style={{
                                height: "300px",
                                color: "#333",
                                fontSize: "16px",
                              }}
                            >
                              Please click on "Add New Item" to add purchase
                              order lines.
                            </span>
                          ),
                        }}
                      />

                      {data?.length > 0 && (
                        <Row
                          style={{
                            margin: "20px",
                          }}
                        >
                          <Col
                            className={`${!["Pending", "Draft", "Requested", "REJECTED", "Rejected"].includes(
                              rfqStatus
                            )
                              ? "justify-between"
                              : "justify-end"
                              }`}
                          >
                            {["Pending", "Draft", "Requested", "REJECTED", "Rejected"].includes(
                              rfqStatus
                            ) && (
                                <a
                                  onClick={() => {
                                    setAddNewRowModel(true);
                                    setEditLineRow(null);
                                  }}
                                  href="#add"
                                  className="addNewItem"
                                >
                                  <Icon name="plus-round" />
                                  <span>Add New Item</span>
                                </a>
                              )}
                          </Col>
                        </Row>
                      )}
                    </Panel>
                    <Panel header="Other Information" key="3">
                      <Descriptions
                        title=""
                        className="custom-description-title"
                      >
                        <Descriptions.Item label="Instructions">
                          <span
                            style={{
                              color: "#2263b3",
                              textDecoration: "underline",
                              cursor: "pointer",
                            }}
                            onClick={() => setInstructionsVisible(true)}
                          >
                            View
                          </span>
                        </Descriptions.Item>
                        <Descriptions.Item label="Terms and Conditions">
                          <span
                            style={{
                              color: "#2263b3",
                              textDecoration: "underline",
                              cursor: "pointer",
                            }}
                            onClick={() => setTermsVisible(true)}
                          >
                            View
                          </span>
                        </Descriptions.Item>

                        <Descriptions.Item label="">
                          <div>
                            <strong
                              className=""
                              style={{
                                display: "flex",
                                whiteSpace: "nowrap",
                              }}
                            >
                              Attachments &nbsp;
                              <PaperClipOutlined />
                              {attachments?.length === 0 &&
                                newAttachments?.length === 0 && (
                                  <div> : N/A</div>
                                )}
                            </strong>
                            <div>
                              {attachments?.length > 0 &&
                                attachments?.map(
                                  (attachment: any, index: number) => (
                                    <div
                                      key={index}
                                      className="w-100 d-flex justify-content-between"
                                    >
                                      <div>
                                        <strong>{index + 1}.</strong>
                                        &nbsp;
                                        {attachment.fileName}
                                        &nbsp; &nbsp; &nbsp; &nbsp;
                                      </div>
                                      <div>
                                        <a
                                          href={attachment.link}
                                          download={attachment.link}
                                          target="_blank" // Opens in a new tab
                                          rel="noopener noreferrer" // Adds security
                                          style={{
                                            color: "black",
                                            fontSize: "18px",
                                          }}
                                        >
                                          <DownloadOutlined />
                                        </a>
                                        &nbsp; &nbsp;
                                        {[
                                          "Pending",
                                          "Draft",
                                          "Requested",
                                        ].includes(rfqStatus) && (
                                            <a
                                              style={{
                                                color: "red",
                                                fontSize: "16px",
                                              }}
                                              onClick={() => {
                                                setDeletedAttachments(
                                                  (prev: any) => [
                                                    ...prev,
                                                    { docId: attachment?.docId },
                                                  ]
                                                );
                                                let updatedAttachmentsList =
                                                  attachments?.filter(
                                                    (item: any, i: number) =>
                                                      i != index
                                                  );
                                                setAttachments(
                                                  updatedAttachmentsList
                                                );
                                                setShowSubmitBtm(true);
                                              }}
                                            >
                                              <DeleteOutlined />
                                            </a>
                                          )}
                                      </div>
                                    </div>
                                  )
                                )}
                              {newAttachments?.map(
                                (attachment: any, index: number) => (
                                  <div
                                    key={index}
                                    className="w-100 d-flex justify-content-between"
                                  >
                                    <div>
                                      <strong>
                                        {attachments?.length + index + 1}.
                                      </strong>
                                      &nbsp;
                                      {attachment?.name}
                                      &nbsp; &nbsp; &nbsp; &nbsp;
                                    </div>
                                    <div>
                                      <a
                                        href={attachment.link}
                                        download={attachment.link}
                                        // target="_blank" // Opens in a new tab
                                        // rel="noopener noreferrer" // Adds security
                                        style={{
                                          color: "black",
                                          fontSize: "18px",
                                        }}
                                      >
                                        <DownloadOutlined />
                                      </a>
                                      &nbsp; &nbsp;
                                      <a
                                        style={{
                                          color: "red",
                                          fontSize: "16px",
                                        }}
                                        onClick={() => {
                                          setNewAttachments((prev: any) =>
                                            prev.filter(
                                              (item: any, i: number) =>
                                                i != index
                                            )
                                          );
                                          setShowSubmitBtm(true);
                                        }}
                                      >
                                        <DeleteOutlined />
                                      </a>
                                    </div>
                                  </div>
                                )
                              )}
                              {["Pending", "Draft", "Requested", "REJECTED", "Rejected"].includes(
                                rfqStatus
                              ) && (
                                  <div className="mt-1">
                                    <Dragger
                                      beforeUpload={beforeUpload}
                                      fileList={[]}
                                      onChange={handleAttachmentChange}
                                    >
                                      <a
                                        onClick={() => { }}
                                        className="addNewItem"
                                      >
                                        <Icon name="plus-round" />
                                        <span>Add Attachment</span>
                                      </a>
                                    </Dragger>
                                  </div>
                                )}
                            </div>
                          </div>
                        </Descriptions.Item>
                        <Descriptions.Item>
                          <div style={{ width: "100%" }}>
                            <strong
                              style={{ color: "#333", fontWeight: "bold" }}
                            >
                              Suppliers
                            </strong>
                            {renderSupplierSection(suppliers)}
                          </div>
                        </Descriptions.Item>
                        {/* {suppliers &&
                                                    <Descriptions.Item label="Suppliers">
                                                        {suppliers.map((item) => (
                                                            <li>
                                                                {item.supplierName}
                                                            </li>
                                                        )
                                                        )}
                                                    </Descriptions.Item>
                                                } */}
                      </Descriptions>
                    </Panel>
                  </AntCollapse>
                </div>

                {/* Sealed Bid Received Modal */}
                <AntModal
                  title={`Sealed Bid Received - ${sealedBidModal.supplierName}`}
                  open={sealedBidModal.open}
                  onCancel={() => {
                    setSealedBidModal({
                      open: false,
                      supplierId: "",
                      supplierName: "",
                    });
                    setSealedBidReceivedDate(null);
                    setSealedBidFile(null);
                  }}
                  onOk={handleSealedBidCapture}
                  confirmLoading={sealedBidSubmitting}
                  okText="Submit"
                >
                  <div style={{ marginBottom: 16 }}>
                    <label
                      style={{
                        display: "block",
                        marginBottom: 6,
                        fontWeight: 500,
                      }}
                    >
                      Received Date & Time{" "}
                      <span style={{ color: "red" }}>*</span>
                    </label>
                    <AntDatePicker
                      showTime={{ format: "hh:mm A", use12Hours: true }}
                      format="DD-MMM-YYYY hh:mm A"
                      value={sealedBidReceivedDate}
                      onChange={(val) => setSealedBidReceivedDate(val)}
                      style={{ width: "100%" }}
                      placeholder="Select date & time"
                    />
                  </div>
                  <div>
                    <label
                      style={{
                        display: "block",
                        marginBottom: 6,
                        fontWeight: 500,
                      }}
                    >
                      Supporting Document
                    </label>
                    <Upload
                      maxCount={1}
                      beforeUpload={(file) => {
                        setSealedBidFile(file);
                        return false;
                      }}
                      onRemove={() => setSealedBidFile(null)}
                      fileList={
                        sealedBidFile
                          ? [
                              {
                                uid: "-1",
                                name: sealedBidFile.name,
                                status: "done" as const,
                              },
                            ]
                          : []
                      }
                    >
                      <button
                        type="button"
                        className="btn btn-sm btn-outline-secondary"
                      >
                        <Icon name="upload-cloud" className="me-1" />
                        Upload File
                      </button>
                    </Upload>
                  </div>
                </AntModal>

                {showEmailModal && (
                  <EmailCreationModal
                    modal={showEmailModal}
                    toggle={() => setShowEmailModal(!showEmailModal)}
                    sendEmail={TriggerEmail}
                    suppliers={formatedSuppliersList}
                    selectedArrayData={selectedArrayData}
                    body={
                      <>
                        <p>
                          We are reaching out to request a quotation for the
                          supply of the following items. Attached, please find
                          the full details of our requirements, including
                          specifications and quantities.
                        </p>

                        <p>
                          <strong>Quotation Request Details:</strong>
                        </p>
                        <p>
                          <strong>Quotation Number:</strong>{" "}
                          {OriginalData?.quotationHeader?.rfqId}
                          <br />
                          {/* <strong>Request Date:</strong>{" "} */}
                          {/* {dayjs(
                              materialData?.quotationHeader?.deliveryDate
                            )?.format("DD-MMM-YYYY")} */}
                          {/* <br /> */}
                          <strong>Quotation Date : </strong>{" "}
                          {dayjs(
                            OriginalData?.quotationHeader?.createdAt
                          ).format("DD-MMM-YYYY")}
                          <br />
                          <strong>Last Submission Date:</strong>{" "}
                          {dayjs(
                            materialData?.quotationHeader?.lastSubmissionDate
                          )?.format("DD-MMM-YYYY")}
                          <br />
                          {/* <strong>Need by Date:</strong>{" "}
                            {dayjs(
                                  materialData?.quotationHeader?.deliveryDate
                                ).format("DD-MMM-YYYY")}
                            <br/> */}
                          <strong>Required by:</strong>{" "}
                          {dayjs(
                            materialData?.quotationHeader?.deliveryDate
                          )?.format("DD-MMM-YYYY")}
                          <br />
                          <strong>Delivery Location:</strong>{" "}
                          {returnDetails(data)?.deliveryAddressString}
                        </p>

                        <p>
                          We would appreciate it if you could provide your best
                          offer, including any applicable discounts, by the
                          requested deadline.
                        </p>

                        <p>
                          For assistance, feel free to reach out to us at{" "}
                          <a href={`mailto:{${currentUser?.email}}}`}>
                            {currentUser?.email}
                          </a>
                          .
                        </p>
                        <p>
                          This is an automatically generated email. Please do
                          not reply directly to this email.
                        </p>
                      </>
                    }
                    defaultAttachments={Object.assign({}, pdfBlobData.current, {
                      name: OriginalData?.quotationHeader?.rfqId + ".pdf",
                      type: "application/pdf",
                    })}
                    orgDetails={{
                      orgLogo: currentUser?.orgLogo,
                      orgName: currentUser?.orgName,
                    }}
                  />
                )}

                {addNewRowModel && (
                  <MaterialModal
                    modal={addNewRowModel}
                    closeModal={() => {
                      setAddNewRowModel(false);
                      setEditLineRow(null);
                    }}
                    status={rfqStatus}
                    formData={{
                      action: editLineRow == null ? "add" : "edit",
                      index: editLineRow?.quotationLineId,
                      siteId: { siteIdWatch },
                      item: editLineRow,
                    }}
                    materialCategoryOptions={materialCategoryOptions}
                    append={(data: any) => {
                      console.log("append", data);
                      let newLineItems = materialData?.quotationLines;
                      const _data = newLineItems.find((item: any) => {
                        if (
                          item.materialId == data.materialId
                          // &&
                          // dayjs(item.needByDate).format("DD-MMM-YYYY") ==
                          // dayjs(data.needByDate).format("DD-MMM-YYYY") &&
                          // item.deliveryAddressId == data.deliveryAddressId
                        )
                          return true;
                      });

                      if (_data) {
                        Swal.fire({
                          icon: "error",
                          title: "Error",
                          text: "Material Already Added",
                        });
                        return;
                      }

                      setMaterialData((pre: any) => {
                        let newData = { ...pre };
                        newData?.quotationLines?.push(data);
                        console.log("addNEW::DATA", newData);
                        return newData;
                      });
                      setData((pre: any) => {
                        return [...pre, data];
                      });
                      setShowSubmitBtm(true);
                    }}
                    update={(id: any, data: any) => {
                      console.log("update", data, id);
                      let newLineItems = materialData?.quotationLines;
                      console.log("newLineItems", newLineItems);
                      const _data = newLineItems
                        .filter((item: any) => item.quotationLineId != id)
                        .find((item: any) => {
                          if (
                            item.materialId == data.materialId
                            // &&
                            // dayjs(item.needByDate).format("DD-MMM-YYYY") ==
                            // dayjs(data.needByDate).format(
                            //     "DD-MMM-YYYY"
                            // ) &&
                            // item.deliveryAddressId == data.deliveryAddressId
                          )
                            return true;
                        });
                      console.log("_dataaa", _data);
                      if (_data) {
                        Swal.fire({
                          icon: "error",
                          title: "Error",
                          text: " Material Already Added",
                        });
                        return;
                      }

                      newLineItems = newLineItems.map((item: any) => {
                        if (item.quotationLineId == id) {
                          return data;
                        }
                        return item;
                      });
                      console.log("newLineItems", newLineItems);
                      setMaterialData((pre: any) => {
                        let newData = { ...pre, quotationLines: newLineItems };
                        console.log("newData", newData);
                        return newData;
                      });
                      setData(newLineItems);
                      setShowSubmitBtm(true);
                    }}
                    materialsList={materialData?.quotationLines?.map(
                      (row: any) => row?.materialId?.toString()
                    )}
                    needByDateType={
                      materialData?.quotationHeader?.deliveryDateType
                    }
                    deliveryAddressType={
                      materialData?.quotationHeader?.deliveryLevelType
                    }
                    siteId={siteIdWatch}
                    deliveryAddressLevel={watch("deliveryAddressType")}
                    boqData={boqData}
                  />
                )}
              </div>
            )}
          </div>
        </Card>
      </Content>
      <Modal
        isOpen={showPdfModal}
        toggle={() => setShowPdfModal(false)}
        className="modal-dialog-centered"
        size={"xl"}
      >
        <ModalHeader
          toggle={() => setShowPdfModal(false)}
          style={{ padding: "0.5rem 1.25rem" }}
        >
          <div
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <span>Quotation Preview</span>
            <span
              style={{
                cursor: "pointer",
                marginLeft: "auto",
                display: "flex",
                alignItems: "center",
                position: "absolute",
                right: "45px",
                fontSize: "13px",
              }}
              onClick={async () => {
                await downloadPDF(pdfBlobData?.doc);
              }}
            >
              Download
              <Icon name="download" className="me-4" />
            </span>
          </div>
        </ModalHeader>
        <ModalBody>
          <iframe
            src={pdfBlobData?.url + "#toolbar=0"}
            style={{
              width: "100%",
              height: "80vh",
              border: "none",
            }}
            title="PDF Viewer"
          ></iframe>
        </ModalBody>
      </Modal>
      <AntModal
        title={undefined}
        visible={instructionsVisible}
        footer={null}
        onCancel={() => {
          setIsInstructionsChanged(false);
          setInstructionsVisible(false);
        }}
        width="60%"
        bodyStyle={{ maxHeight: "70vh", overflowY: "auto" }}
      >
        <div className="d-flex">
          <h5 className="m-3">Instructions </h5>
          {!isInstructionsChanged &&
            ["Pending", "Draft", "Requested", "REJECTED", "Rejected"].includes(rfqStatus) && (
              <EditOutlined onClick={() => setIsInstructionsChanged(true)} />
            )}
        </div>
        {["Pending", "Draft", "Requested", "REJECTED", "Rejected"].includes(rfqStatus) &&
          isInstructionsChanged ? (
          <FormProvider {...methods}>
            <form>
              <div className="mt-1 mb-3">
                <FormTextArea
                  name="instructions"
                  label=""
                  placeholder="Enter Instructions"
                  required
                  rows={10}
                  defaultValue={newInstructions}
                />
              </div>
            </form>
          </FormProvider>
        ) : instructions ? (
          <pre className="m-3">{instructions || ""}</pre>
        ) : (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "200px",
            }}
          >
            <Empty description="No Instructions Available for this Purchase Order" />
          </div>
        )}
        {isInstructionsChanged && (
          <ul className="actions clearfix d-flex">
            <li>
              <Button
                color="primary"
                type="submit"
                onClick={() => {
                  setInstructionsVisible(false);
                  setIsInstructionsChanged(true);
                  setShowSubmitBtm(true);
                }}
              >
                Submit
              </Button>
            </li>
            <li className="m-3 mt-0">
              <Button
                color="primary"
                onClick={() => {
                  setIsInstructionsChanged(false);
                  setNewInstructions(instructions);
                }}
                className="btn-dim btn btn-secondary"
              >
                Cancel
              </Button>
            </li>
          </ul>
        )}
      </AntModal>
      <AntModal
        title={undefined}
        visible={termsVisible}
        footer={null}
        onCancel={() => {
          setIsTermsAndConditionsChanged(false);
          setTermsVisible(false);
        }}
        width="60%"
        bodyStyle={{ maxHeight: "70vh", overflowY: "auto" }}
      >
        <div className="d-flex">
          <h5 className="m-3">Terms and Conditions</h5>
          {!isTermsAndConditionsChanged &&
            ["Pending", "Draft", "Requested", "REJECTED", "Rejected"].includes(rfqStatus) && (
              <EditOutlined
                onClick={() => setIsTermsAndConditionsChanged(true)}
              />
            )}
        </div>
        {["Pending", "Draft", "Requested", "REJECTED", "Rejected"].includes(rfqStatus) &&
          isTermsAndConditionsChanged ? (
          <FormProvider {...methods}>
            <form>
              <div className="mt-1 mb-3">
                <FormTextArea
                  defaultValue={newTermsAndConditions}
                  name="termsAndConditions"
                  label=""
                  placeholder="Enter Terms and Conditions"
                  required
                  rows={10}
                />
              </div>
            </form>
          </FormProvider>
        ) : termsAndConditions ? (
          <pre className="m-3">{termsAndConditions || ""}</pre>
        ) : (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "200px",
            }}
          >
            <Empty description="No Terms and Conditions Available for this Quotation" />
          </div>
        )}

        {isTermsAndConditionsChanged && (
          <ul className="actions clearfix d-flex">
            <li>
              <Button
                color="primary"
                type="submit"
                onClick={() => {
                  setTermsVisible(false);
                  setIsTermsAndConditionsChanged(true);
                  setShowSubmitBtm(true);
                }}
              >
                Submit
              </Button>
            </li>
            <li className="m-3 mt-0">
              <Button
                color="primary"
                onClick={() => {
                  setIsTermsAndConditionsChanged(false);
                  setNewTermsAndConditions(termsAndConditions);
                }}
                className="btn-dim btn btn-secondary"
              >
                Cancel
              </Button>
            </li>
          </ul>
        )}
      </AntModal>
      <AntModal
        title="Reject RFQ"
        visible={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        okText="Submit"
        cancelText="Cancel"
      >
        <Form form={form} layout="vertical" name="rejectForm">
          <Form.Item
            name="reason"
            label="Reason for Rejection"
            rules={[{ required: true, message: "Please input your reason!" }]}
          >
            <Input.TextArea placeholder="Type your reason here..." />
          </Form.Item>
        </Form>
      </AntModal>

      <AntModal
        title="Approve RFQ"
        visible={isModalApproveVisible}
        onOk={() => {
          if (!signature.image) {
            Swal.fire({
              icon: "info",
              title: "Signature Required",
              text: "Please add your signature before approving.",
            });
            return;
          }
          openApproveConfirmSwal();
        }}

        onCancel={() => {
          setIsModalApproveVisible(false);
          setSignature({ isActive: false, label: "Authorised Signatory", image: null });
        }}
        okText="Submit"
        cancelText="Cancel"
        width={600}
      >
        <div className="p-3">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <span style={{ fontSize: 14, fontWeight: 600 }}>Signature</span>

            {signature.image && (
              <button
                type="button"
                onClick={() =>
                  setSignature({
                    isActive: true,
                    label: "Authorised Signatory",
                    image: null,
                  })
                }
                style={{
                  border: "none",
                  background: "transparent",
                  padding: 0,
                  cursor: "pointer",
                }}
              >
              </button>
            )}
          </div>

          {signature.image ? (
            <>
              <div
                className="border mb-3 d-flex justify-content-center align-items-center"
                style={{
                  padding: 16,
                  borderRadius: 8,
                  background: "#fff",
                }}
              >
                <img
                  src={signature.image}
                  alt="Signed"
                  style={{ maxWidth: 220, maxHeight: 120, objectFit: "contain" }}
                />
              </div>

              <div className="d-flex justify-content-between align-items-center mb-3">
                <Button
                  size="sm"
                  color="outline-secondary"
                  onClick={() =>
                    setSignature({
                      isActive: true,
                      label: "Authorised Signatory",
                      image: null,
                    })
                  }
                >
                  Reset
                </Button>
              </div>
            </>
          ) : (
            <div
              style={{
                width: "100%",
                minHeight: 220,
                border: "2px dashed #dee2e6",
                borderRadius: 8,
                backgroundColor: "#f8f9fa",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: 24,
              }}
            >
              <div
                style={{
                  display: "flex",
                  gap: 12,
                  justifyContent: "center",
                  alignItems: "center",
                  flexWrap: "wrap",
                }}
              >
                <ImageUploadCropper
                  onOpenCrop={() => setIsModalApproveVisible(false)}
                  onCloseCrop={() => setIsModalApproveVisible(true)}
                  onSave={(data: string) => {
                    setSignature((prev: any) => ({ ...prev, image: data }));
                  }}
                >
                  <Button color="primary" size="sm" outline style={{ minWidth: 140 }} onClick={() => setActiveSignatureContext("APPROVE")}>
                    <Icon name="upload-cloud" className="me-1" />
                    Upload Image
                  </Button>
                </ImageUploadCropper>

                <Button
                  color="outline-primary"
                  size="sm"
                  style={{ minWidth: 140 }}
                  onClick={() => {
                    setIsModalApproveVisible(false);
                    setShowSignatureModel(true);
                  }}
                >
                  <Icon name="pen" className="me-1" />
                  Signature Pad
                </Button>
              </div>
            </div>
          )}
        </div>
      </AntModal >

      <AntModal
        title="Reject RFQ"
        visible={isModalRejectedVisible}
        onOk={openRejectConfirmSwal}
        onCancel={() => {
          handleCancel();
          setSignature({ isActive: false, label: "Authorised Signatory", image: null });
        }}
        okText="Submit"
        cancelText="Cancel"
        width={600}
      >
        <Form form={form} layout="vertical" name="rejectForm">
          <Form.Item
            name="reason"
            label="Reason for Rejection"
            rules={[{ required: true, message: "Please input your reason!" }]}
          >
            <Input.TextArea rows={3} placeholder="Type your reason here..." />
          </Form.Item>

          <div className="mt-4">
            <strong style={{ fontSize: "16px" }}>Signature</strong>
          </div>

          {signature.image && (
            <a
              style={{ fontSize: 14, cursor: "pointer" }}
              onClick={() =>
                setSignature({ isActive: true, label: "Authorised Signatory", image: null })
              }
            >
            </a>
          )}


          {signature.image ? (
            <>
              <div className="signatueImgWrapper border mb-3 p-3 text-center">
                <img
                  src={signature.image}
                  alt="Signed"
                  style={{ width: "180px", height: "auto" }}
                />
              </div>
              <div className="d-flex justify-content-end mb-3">
                <Button
                  size="sm"
                  color="outline-secondary"
                  className="me-2"
                  onClick={() =>
                    setSignature({ isActive: true, label: "Authorised Signatory", image: null })
                  }
                >
                  Reset
                </Button>
              </div>

            </>
          ) : (
            <div
              style={{
                minHeight: "200px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                gap: "15px",
                border: "2px dashed #dee2e6",
                borderRadius: "8px",
                backgroundColor: "#f8f9fa"
              }}
            >
              <div style={{ display: "flex", gap: "10px", flexWrap: "wrap", justifyContent: "center" }}>
                <ImageUploadCropper
                  onOpenCrop={() => setIsModalRejectedVisible(false)}
                  onCloseCrop={() => setIsModalRejectedVisible(true)}
                  onSave={(data: string) => {
                    setSignature((prev: any) => ({ ...prev, image: data }));
                  }}
                >
                  <Button color="primary" size="sm" outline onClick={() => setActiveSignatureContext("REJECT")}>
                    <Icon name="upload-cloud" className="me-1" />
                    Upload Image
                  </Button>
                </ImageUploadCropper>

                <Button
                  color="outline-primary"
                  size="sm"
                  onClick={() => {
                    setIsModalRejectedVisible(false);
                    setShowSignatureModel(true);
                  }}
                >
                  <Icon name="pen" className="me-1" />
                  Signature Pad
                </Button>
              </div>
            </div>
          )}
        </Form>
      </AntModal>


      {showSignatureModel && (
        <SignatureModal
          modal={showSignatureModel}
          toggle={() => {
            setShowSignatureModel(false);
            if (activeSignatureContext === "APPROVE") {
              setIsModalApproveVisible(true);
            } else if (activeSignatureContext === "REJECT") {
              setIsModalRejectedVisible(true);
            }
          }}
          onSave={(data: string) => {
            setSignature((prev: any) => ({ ...prev, image: data }));
            setShowSignatureModel(false);

            if (activeSignatureContext === "APPROVE") {
              setIsModalApproveVisible(true);
            } else if (activeSignatureContext === "REJECT") {
              setIsModalRejectedVisible(true);
            }
          }}
        />
      )}
    </>
  );
};

export default ViewDetailsEdit;
